// App changelog data (release log) extracted verbatim from the monolith.
// This is the source of truth for the in-app changelog view and APP_VERSION
// (CHANGELOG_DATA[0].version). Keep in sync with CHANGELOG.md per HANDOVER §14.
export const CHANGELOG_DATA = [
  {
    version: '1.19.0',
    name: 'Mobilapp, Reporting & fulle banepads',
    pushedAt: '2026-09-09T22:30:00+02:00',
    date: 'september 2026',
    summary:
      'Den største utgivelsen siden appen ble et ekte kodeprosjekt. Fire nye ting for klubben: medlemsappen (Mobilapp v1–v1.2 — book bane, meld deg på, se kampene dine, legg inn resultat og følg ELO — forhåndsvist som en telefon inne i klubbsiden, og nå også som ekte app for iOS/Android via et Expo-skall), Reporting (avregningsgrunnlag per senter og måned, hver booking og påmelding som en kvittering, med plattformavgift og «til utbetaling»), fulle banepads (live score på alle formater, turneringsdashboard, auto-force-vindu, seriespill-pad og enkeltkamp fra booking rett på paden) og sluttspill for små KM-klasser. Under panseret er repoet blitt et monorepo med Postgres-database og eget API, alle modalene i appen er reparert, og feilrapporter sendes faktisk på e-post. Engine er bumpet til 1.15.0.',
    sections: [
      {
        type: 'new',
        emoji: '📱',
        title: 'Mobilapp (v1 → v1.2) — medlemsappen',
        items: [
          'Ekte app for iOS/Android (Expo-skall, v1): medlemsappen kan installeres som app. Et Expo-skall laster portalen i en WebView i frittstående visning (uten toppmeny, telefonramme og innlogging — spilleren velger seg selv), med push-varslinger fra Profil og en typet bro mellom web og app.',
          'Ny modul «Mobilapp»: en frittstående medlemsapp (full høyde, egen bunnmeny) forhåndsvist i en telefonramme inne i klubbsiden — med touch-effekt for musa. Hovedmeny: Hjem · Spill · Reservasjoner · Kamper · Profil.',
          'Velg bruker («Hvem er du?»-ark med søk og nivå, tvinges fram første gang). Alt i appen gjøres som den valgte spilleren; avataren øverst åpner Profil.',
          'Padelsentre: søk, favoritt og filter. Hvert senter har egen side med Om · Book · Aktiviteter · Matcher. «Spill» er senteret ditt.',
          'Booking på én skjerm: kalenderstripe, starttider med alle ledige baner, grafisk varighetslinje per bane (60 → 90 → 120 med pris), bookingark i bunnen som kan minimeres, mock-betaling — gjenbruker booking-motoren uendret.',
          'Registrer en kamp fra bookingen: du tar første plass, tre plasser ligger åpne under Matcher der andre kan melde seg på/av. Nivåkrav (laveste/høyeste, forhåndsutfylt med ditt nivå ±1), legg til/fjern spillere, og legg inn resultat sett-for-sett når laget er fullt.',
          'Aktiviteter følger skrivebordets regler for tid, «åpen» og påmeldingsfrist; filter «Passer mitt nivå»; meld på/av med venteliste og betaling.',
          'Kamper: Kommende (pågående turneringer med dine kamper + «Legg inn resultat», og planlagte enkeltkamper) · Spilt (resultat, ELO-endring, plasseringer). Seriespill som egen bryter inne i Kamper. Etternavn i alle oppsett, du selv uthevet i lime.',
          'Hjem: «Neste for deg» viser neste turneringskamp før neste booking. Nivåkortet åpner en egen ELO-side med poeng til neste nivå, trend 30/90 dager, utviklingskurve og siste endringer (rekonstruert fra alle registrerte ELO-endringer).',
          'Reservasjoner: alle bookingene dine, enkeltkamper og påmeldinger i Kommende / Tidligere. Tilbake-pilen holder seg inne i appen.',
        ],
      },
      {
        type: 'new',
        emoji: '🧾',
        title: 'Reporting — avregningsgrunnlag per senter',
        items: [
          'Nytt menypunkt «Reporting»: hver booking, aktivitetspåmelding og seriespill-sesongavgift som en kvitteringslinje (dato, bane/aktivitet, betaler, betalingsmåte, referanse, beløp, status Betalt · Utestående · Gratis · Refundert), samlet per måned og per senter.',
          'Måneden avregnes mot plattformens avgiftsmodell — en prosent av hver betalte transaksjon pluss et fast månedsbeløp — i et kvitteringsformet avregningskort med brutto, avgifter og «Til utbetaling». Avgiftsmodellen (standard 3 % + 990 kr/mnd) redigeres i modulen og lagres per klubb.',
          'Statusfilter, søk på betaler/bane/referanse, klikk på en linje for full kvittering med avgift og netto til senteret, utskrift og CSV-eksport som åpnes rett i Excel. Demo-bookinger fra testdata er utelatt som standard.',
        ],
      },
      {
        type: 'new',
        emoji: '🖥',
        title: 'Banepad — fulle pads, live score, dashboard & auto-force',
        items: [
          'Live score på ALLE banepad-formater (enkeltkamp, KM, seriespill, Padel24, americano): poengene lagres fortløpende mens man taster, paden gjenopptar etter reload, og rutenett/dashboard viser stillingen. «Send resultat» fullfører som før.',
          'Turneringsdashboard fra sentralen: «Spilles nå»-tavle + stilling for den aktive turneringen/serien; Padel24 vises per fasegruppe. Lesbar kontrast på storskjerm.',
          'Auto-force-vindu: global regel (minutter før/etter bookingen, «etter slutt kun til resultater er sendt») som automatisk viser turneringen på banene den bruker. Manuell force klareres automatisk når turneringen er ferdig eller vinduet er passert. Status-chip i sentralen viser hva som er forced/auto.',
          'Seriespill-pad (banepad-fane i Seriespill, force fra sentralen) med divisjonstabell som footer. Klubb-banner pinnet inne i paden, scroll-pinning av pågående kamp.',
          'Banepad på egne nettbrett: enhets-token-rute, kortlivet paringskode med live status fra sentralen, pad-innholdet rendres på enheten i fullskjerm.',
          'Fiks: en americano «hang» på alle padene — kamper uten starttid kapret paden for alltid. Nå tar en turnering paden kun når en kamp faktisk pågår, eller når den er forced.',
          'Fiks: enkeltkamp vistes som anonym «Booking» på paden; «Kommer opp» på KM-paden viser fulle navn.',
        ],
      },
      {
        type: 'new',
        emoji: '🎾',
        title: 'Enkeltkamp — fra booking til banepad',
        items: [
          'Registrer en enkeltkamp på en banebooking (booker foreslås som spiller A, «3 fulle sett» + starpoint som standard, nivåkrav fra/til). Spillerne kan byttes fram til start.',
          'Enkeltkamp-pad i den vanlige bane-rammen med live, fortløpende resultat (+/− per lag, settlogikk etter format), force fra sentralen, og egen banepad-visning fra Enkeltkamper-siden. Rutenettet viser hvem som spiller og stillingen.',
          'Lokale planlagte kamper (ikke bare via Aktiviteter) støttes hele veien: resolver, force, rutenett, live score og «Send resultat» med ELO.',
        ],
      },
      {
        type: 'adjustments',
        emoji: '🏆',
        title: 'Klubbmesterskap & banebooking',
        items: [
          'KM-klasser med under 8 par: velg per klasse «Gruppe · vinner blir mester» (standard — seriespill), «Gruppe + finale (topp 2)», «Gruppe + semifinaler (topp 4)» eller «Ren cup». Sluttspill-panelet vises også for én gruppe.',
          'Fiks: en ren cup fikk bare første runde — nå bygges semifinaler og finale (og bronse) også for klasser uten gruppespill, og klasser som ikke er en toerpotens får byes i stedet for ingen bracket.',
          'Banebooking: «Inndeling»-knapp slår Morgen/Formiddag/Ettermiddag/Kveld av og på (huskes). Fiks: time- og minuttvelgerne i «Ny booking» klippet sifrene.',
        ],
      },
      {
        type: 'bugs',
        emoji: '🐛',
        title: 'Rettelser & robusthet',
        items: [
          'Alle modaler i appen lå fanget under den klistrede headeren (en «forwards»-animasjon på sideinnholdet ga en evig stablingskontekst) — rotfikset, og KM-resultatboksen har fått maks-høyde med intern scroll så «Lagre» alltid er nåbar.',
          'Feilrapporter ble aldri sendt på e-post i den utrullede appen (tom Web3Forms-nøkkel i Docker-imaget) — nøklene sendes nå inn i bygget, og en test låser at Infisical, Dockerfile og CI holder seg i takt. Én kopiert rapport er nok til å handle på.',
          'Alle pågående turneringer og serier persisteres blankt og overlever redeploy. Pausede turneringer minimert på forsiden; «Lagre og avslutt» på en uferdig turnering gir advarsel. Force-turnering reverterte etter resultat — fikset.',
          'Meny: Banebooking, Aktiviteter, Banepad, Mobilapp og Reporting; «Aktivitetsarkiv» heter «Turneringsarkiv».',
        ],
      },
      {
        type: 'tech',
        emoji: '🛠',
        title: 'Teknisk & plattform',
        items: [
          'pnpm-monorepo (apps/web, apps/api, packages/db). Postgres/Prisma-bro med Hono-API og http-lagringsbackend bak samme Storage-kontrakt; spillere, ELO, kamper, tenants, innstillinger, feilrapporter, banepad-enheter, aktiviteter og bookinger som relasjonelle tabeller. Migrasjonssjekk i CI.',
          'Monolitten er borte: hele appen er typede moduler, legacy/App.tsx er slettet, kodekommentarer på engelsk. CI kjører Prettier · Lint · Typecheck · Tests · Build som separate statuser; grønn CI = merge (ingen review-krav før prod). 900+ tester.',
          'Engine 1.15.0: KM-bracket med byes, ren-cup-runder og tvunget sluttspill for én gruppe; banepad-resolver som kun tar paden ved pågående kamp, force av enkeltkamp/serie, auto-klarering og auto-force-kontekst; ny Reporting-motor og felles kroneformat.',
        ],
      },
    ],
  },
  {
    version: '1.18.0',
    name: 'Banepad — sentral & generell pad (fundament)',
    pushedAt: '2026-06-17T18:00:00+02:00',
    date: 'juni 2026',
    summary:
      'Ny modul «Banepad» — skjermene som henger ved hver bane (iPad/Samsung Tab) og en sentral hovedskjerm som viser hva som skjer på ALLE baner live. Dette er fundamentet (v1): den generelle paden som viser hvem som spiller nå / hvem som har booket banen, med før/nå/senere utledet fra klubbens kalender, og sentralen som samler alle baner i ett rutenett. Når Padel24 eller Klubbmesterskap kjører på en bane, vises et live-sammendrag med en knapp som tar deg rett til deres egne banepad-visninger. En skjerm kan låses til én bane (kiosk) på enheten. Full americano-pad med egen live resultat-innlegging kommer i neste runde. Merk: ekte deling til separate nettbrett krever server (kommer) — live-data oppdateres på enheten.',
    sections: [
      {
        type: 'new',
        title: 'Banepad — generell pad ved banen',
        items: [
          'Fullskjerm, glanceable pad-visning per bane: stort banenavn, klokke og en tydelig NÅ-blokk. Booking-modus viser hvem som har booket, tidsrom og notat, pluss «senere i dag».',
          'Før/nå/senere utledes fra klubbens felles kalender (bookings) med lokal dato/tid — også over midnatt.',
          'Ledig bane viser «Banen er ledig» + neste booking i dag.',
          'Pad-skjermene er i iPad-format (4:3). Starpoint-logoen vises øverst mot en nær-sort, premium bakgrunn med gull-aksent, og hele Starpoint-lockupen (merke med hvit stjernebunn + «PADEL PORTAL») vises stort når banen er ledig. Sponsorlogo per bane (fra banens innstillinger) vises diskré nederst — kun på sponsede baner.',
          'Kiosk: «Lås skjerm til banen» fester enheten til én bane så den alltid viser den paden (lagres per enhet).',
        ],
      },
      {
        type: 'new',
        title: 'Sentral hovedskjerm — alle baner live',
        items: [
          'Ny «Banepad»-modul på forsiden (fjerde modul) → sentral oversikt med alle baner i et rutenett, live-klokke og «X/N i bruk».',
          'Hver bane viser status (Ledig / Booket / Live / Neste) med farge, hvem/hva som er på banen nå, og neste opp. Trykk en bane → fullskjerm-pad.',
          'Visnings-toggle: «Rutenett» (kompakt oversikt) eller «Forhåndsvis pads» — de faktiske pad-skjermene stablet under hverandre så du ser nøyaktig hva som vises på hver bane ved å scrolle nedover.',
          'Forsidens «Baner nå»-firkant viser kompakt status per bane med fargeprikk.',
        ],
      },
      {
        type: 'new',
        title: 'Turnering på banen',
        items: [
          'Når Padel24/Klubbmesterskap kjører på en bane, vises et live-sammendrag (format, navn, pågående/neste kamp + resultat) med knapp «Åpne {format}-banepad» som switcher til deres eksisterende visning.',
          'Seriespill-kamper plassert på baner vises på samme måte, med snarvei til Seriespill.',
          'Auto-deteksjon av hva som kjører (turnering → serie → booking → ledig), kan utvides med manuell overstyring senere.',
        ],
      },
      {
        type: 'tech',
        title: 'Teknisk',
        items: [
          'Rene, testbare hjelpere: banepadCourtList, banepadTimelineForCourt, banepadFindCourtMatch, banepadResolveCourt (16/16 enhetstester grønt i Node, TZ=Europe/Oslo).',
          'Gjenbruker courtDisplayName og klubbens baneliste — ingen parallell motor. Kritiske farger inline (cyan-familie) jf. prosjektregler.',
          'Banepad-view ligger i app-shellen og kolliderer ikke med KM-komponentens interne «banepad»-fane (separat lokal view-state).',
          'Per-enhet kiosk-lås lagres i banepad_device_v1. Engine (PlatformEngine) uendret 1.14.0.',
        ],
      },
    ],
  },
  {
    version: '1.17.0',
    name: 'Startside — moduler, navigasjon & kalender',
    pushedAt: '2026-06-17T12:00:00+02:00',
    date: 'juni 2026',
    summary:
      'Startsiden er bygget om til tre tydelige moduler — Turneringer, Banebooking og Aktiviteter — der hver modul er TO separate firkanter: et stort fargekort du kan trykke hvor som helst på for å åpne, og en egen lys info-firkant ved siden av med snarveier rett inn. Turnerings-firkanten har piller for Padel24, Klubbmesterskap og Miniturneringer (rett til oppsettet). Banebooking-firkanten viser ledighet de neste 7 dagene loddrett, med tre prikker per dag (tidlig/midt/kveld) — trykk en dag for å åpne booking direkte på den datoen. Aktivitets-firkanten viser de tre nærmeste aktivitetene, klikkbare. Padel24-heroen er fjernet fra forsiden (nås nå via «alle turneringer» og Aktiviteter). I tillegg er de to egendefinerte kalenderne (banebooking + KM-oppsett) gjort om til kompakte, sentrerte overlays så de ikke klippes i kanten. Denne versjonen samler også opp arbeidet med påmelding via Aktiviteter (påmeldingsbasen — venteliste, status-tagger, gjentakelse, maler, selvbetjent påmelding), format-spesifikk påmelding (lag, kjønns- og klubbkvoter) og beredskapsreserver for Padel24 — ting som var bygget, men ikke fanget i endringsloggen før nå.',
    sections: [
      {
        type: 'new',
        title: 'Startside som moduler',
        items: [
          'Tre moduler på forsiden: Turneringer, Banebooking og Aktiviteter. Hver modul er to firkanter side om side — hovedkort (fargegradient) + en egen info-firkant (lys tone av samme farge), med mellomrom imellom og felles høyde.',
          'Hele hovedkortet er klikkbart og åpner modulens hovedside. Snarveiene i info-firkanten går rett til riktig sted og stopper kort-klikket, så du kan trykke hvor som helst — eller direkte på en snarvei.',
          'Turnerings-firkanten «Velg format»: piller for Padel24 (→ wizard-oppsett), Klubbmesterskap (→ KM-oppsett) og Miniturneringer (→ mini-siden med alle variantene). Enkeltkamper og resten nås via «Se alle formater».',
        ],
      },
      {
        type: 'new',
        title: 'Ledighet & nærmeste aktiviteter',
        items: [
          'Banebooking-firkanten «Ledighet 7 dager»: dagene loddrett, hver med tre prikker (tidlig / midt på dagen / kveld) i samme fargetrinn som booking-kalenderen. Trykk en dag → booking åpnes direkte på den datoen.',
          'Aktivitets-firkanten «Nærmeste aktiviteter»: de tre nærmeste kommende aktivitetene (navn + ukedag/dato/tid), klikkbare rett inn i aktiviteten.',
          'Padel24-heroen er fjernet fra forsiden — Padel24 opprettes nå via «alle turneringer» eller Aktiviteter.',
        ],
      },
      {
        type: 'design',
        title: 'To firkanter per modul + farger',
        items: [
          'Info-firkantene er egne kort (ikke lenger boks-i-boks) med lys gradient i modulens farge: lime (Turneringer), emerald (Banebooking) og violet (Aktiviteter). Pillene/dagene/aktivitetene er godt lesbare mot den lyse tonen.',
          'Kortene har mer luft mellom seg og lik minstehøyde, så hver modul står som tydelige, jevne firkanter.',
        ],
      },
      {
        type: 'tech',
        title: 'Kalender-overlays, layout & diverse',
        items: [
          'CalendarPopover (banebooking) og KMDatePicker (KM-/enkeltkamp-oppsett) er gjort om fra absolutt-posisjonerte popovere til kompakte, sentrerte overlays med dim-bakgrunn — ingen klipping i hjørnet, og riktig klikk-treff på dagen.',
          'BookingView tar nå `initialDate` (åpne på en bestemt dato). Ny app-shell-handler `onOpenSetup(target)` gir fersk, direkte inngang til hvert turnerings-oppsett fra forsiden.',
          'LÆRDOM: arbitrary/responsive Tailwind-bredder (`w-[..]`, `sm:w-[..]`) kompilerer IKKE i dette miljøet — bruk inline `style` (flex/width) for breddestyring.',
          'Diverse siden 1.16.0: King of Court fjernet som format; coaching/arrangement/egendefinert aktivitet gjenbruker americano-oppsettet (alene/par-valg, turneringsinnstillinger skjult); «Tilbake» fra oppsett åpnet via Aktiviteter går tilbake til Aktiviteter; Seriespill sesongpåmelding fikk egen «Meld av»-knapp; per-klasse overstyring av fri-booking-rabatt/vindu i Seriespill.',
        ],
      },
      {
        type: 'new',
        title: 'Påmelding via Aktiviteter (påmeldingsbasen)',
        items: [
          'Aktiviteter-modulen kan nå kjøre turneringer med spiller-påmelding: en aktivitet publiseres og «venter på påmelding», spillere melder seg på, og turneringen starter med de påmeldte.',
          'Selvbetjent påmelding («Meld deg på») med søk, makker-velger, og «+ Ny spiller» rett i flyten. Admin-visning med alle valg vs. enkel brukervisning. Demo-profilbytter («innlogget som»).',
          'Venteliste når kapasiteten er full (X/4) med hint om at det trengs ekstra bane. Status-tagger på aktivitetene: [Type] [Nivå] [Status]. Filtrering/sortering på status, type og sted.',
          'Gjentakende aktiviteter (fast antall eller fortløpende) med serienavn + kode, og 3-veis rediger/slett (denne / denne og fremtidige / hele serien). Banebooking gjenbruker SerieBookingPanel (kalender/frittstående + Geonorge-adressesøk). Ukesegmenter og dag + dato før klokkeslett i listene.',
          'Navngitte maler så et oppsett kan gjenbrukes. Betalingsflyt per påmelding (individuell / single / par).',
        ],
      },
      {
        type: 'new',
        title: 'Format-spesifikk påmelding',
        items: [
          'Team- og Mixicano-formater: lagpåmelding — to spillere melder seg på sammen som par (med makkerbytte).',
          'Mix Americano / Mix Mexicano: kjønnskvoter i påmelding og venteliste (lik fordeling menn/damer), med admin-overstyring.',
          'Club-formater (Club Americano / Club Mexicano / Club Team Americano): spilleren velger hvilken klubb hen representerer, med klubbkvote (like mange fra hver av to klubber).',
          'Klubbmesterskap: par melder seg på en bestemt klasse. Padel24: gruppe-/pulje-påmelding.',
        ],
      },
      {
        type: 'new',
        title: 'Beredskapsreserver (Padel24)',
        items: [
          'Påmelding kan ha vanlige reserver (venteliste) og egne beredskaps-KUN-reserver som holdes utenfor den bekreftede poolen og ventelista.',
          'Beredskapsvalg (med antall dager) tas før betaling; reservene sorteres på påmeldingstidspunkt og bæres med inn i turneringen i rekkefølge.',
          'Konfigurerbart: tillat reserver, maks reserver og maks beredskapsreserver. Walkover registrert i banepad lagrer tidsstempel og holdes utenfor ELO.',
        ],
      },
    ],
  },
  {
    version: '1.16.0',
    name: 'Seriespill — Banebooking & kalender',
    pushedAt: '2026-06-08T20:00:00+02:00',
    date: 'juni 2026',
    summary:
      'Stor utvidelse av Seriespill: fullt banebooking-oppsett rett i serien. Du setter opp faste tidsrom (spilledager, klokkeslett, baner) med gjentakelse og helligdag-hopp, reserverer slottene i klubbens felles kalender (med ledighetssjekk) eller kjører frittstående uten kalenderlagring, og plasserer kampene i slottene. Ny kalender-fane viser hvem som spiller når, med «Flytt kamp»-popup, historikk og klikkbare navn. Booking-oppsettet er nå én delt editor som finnes både under Hovedinnstillinger og som egen fane i klasse-innstillingene (når klassen bruker allokerte baner). Header-merkene og knappene står fast uansett klasse, og kalender-fanen vises kun for allokerte klasser.',
    sections: [
      {
        type: 'new',
        title: 'Banebooking i Seriespill',
        items: [
          'Tidsrom-oppsett per serie: faste spilledager, klokkeslett, varighet og baner. Hvert tidsrom kan dekke én eller flere klasser, og du velger baner fra klubbens faktiske baner.',
          'Gjentakelse identisk med «Ny booking»: Daglig/Ukentlig/Månedlig/Årlig, «hver N.», valgte ukedager, og «slutter» (etter antall / på dato / aldri). Helligdager kan hoppes over (samme helligdagssett som klubbens bookinger).',
          'To-stegs flyt: «1. Reserver slottene i kalenderen» (skriver til klubbens felles kalender med ledighetssjekk) og «2. Plasser kampene i slotene» (legger kampene på dato/tid/bane). Plassering er inkrementell — fyller kun kamper uten dato, så den kan kjøres fortløpende.',
          'Frittstående modus: samme oppsett (datoer, helligdager, gjentakelse, baner), men uten å reservere i Padelsenter-kalenderen og uten ledighetssjekk — kampene legges kun på banene du angir.',
          'Behovs-panel: anslår hvor mange kamper hver spiller spiller per måned, og varsler om du booker for få eller for mange slots i forhold til antall kamper i sesongen.',
          'Fast kalender: når klassen kjører allokert via klubbens kalender, fjernes rundefristen — runden er ferdig når siste kamp er spilt (datadrevet).',
        ],
      },
      {
        type: 'new',
        title: 'Kalender-fane',
        items: [
          'Ny «📆 Kalender»-fane ved siden av kampprogrammet viser de reserverte tidene og hvem som spiller, gruppert per spilledag, med fyllingsgrad totalt og per dag.',
          'Spilte/passerte kamper legges i en utvidbar «Historikk»-seksjon med sluttresultat. Klassefarger på radene (Herrer blå, Damer rosa, Mix lilla).',
          'Spillernavn i kalenderen er klikkbare og åpner spiller-modalen — som i tabell og kampprogram.',
          '«Flytt kamp»-popup (KM-stil): hver dag viser grønn/oransje/rød indikator etter hvor mange trygge tider som finnes. Du kan flytte en kamp til en ledig tid eller bytte med en annen kamp; kollisjonssjekk hindrer at et par får to kamper samtidig eller rett etter hverandre.',
          '«Fjern seriens bookinger»-knappen vises kun når serien faktisk har bookinger i kalenderen.',
        ],
      },
      {
        type: 'new',
        title: 'Banebooking-fane i klasse-innstillinger',
        items: [
          'Booking-editoren er trukket ut i én delt komponent (SerieBookingPanel) som brukes både under Hovedinnstillinger → Banebooking og som egen fane i klasse-innstillingene.',
          'Klasse-innstillinger får en «Banebooking»-fane mellom Innstillinger og Divisjoner & spillere — men kun når klassen bruker allokerte baner. Den redigerer seriens felles oppsett, fokusert på klassen, og lagrer rett til serien.',
        ],
      },
      {
        type: 'design',
        title: 'Header & faner står fast',
        items: [
          'Merket i headeren viser den valgte klassens modus: «Fri booking», «Allokert · Banebooking» eller «Allokert · frittstående».',
          '«Sesong låst» og «Start sesong»-knappen har nå fast bredde og reservert plass, så merker og knapper ikke flytter seg når du bytter mellom klasser. Detaljer om låsing ligger i tooltip.',
          'Kalender-fanen vises kun for klasser med allokerte baner. På en fri-booking-klasse skjules den, og du faller tilbake til kampprogrammet automatisk.',
          'Fullførte runder i kampprogrammet minimeres ikke lenger med én gang du fyller siste resultat — de blir stående synlige til neste gang du går inn (da tas et nytt øyeblikksbilde av hva som var ferdig).',
        ],
      },
      {
        type: 'tech',
        title: 'Slot-motor & datoer',
        items: [
          'serieGenerateSlots: delt, ren slot-generator (gjentakelse + helligdag-filter, lokal datoformat) brukt av både reservering (med ledighetssjekk) og frittstående plassering og kalendervisning — så de holder seg identiske.',
          'serieBuildReservations refaktorert til å bruke serieGenerateSlots. serieAssignMatchesToSlots plasserer kamper inkrementelt og hopper over tider der et lag alt spiller.',
          'Datoformatering bruker lokal YYYY-MM-DD (ikke toISOString) for å unngå at spilledager forskyves én dag i norsk tidssone.',
        ],
      },
    ],
  },
  {
    version: '1.15.2',
    name: 'Seriespill — start sesong & demo-fiks',
    pushedAt: '2026-06-04T18:00:00+02:00',
    date: 'juni 2026',
    summary:
      'Seriespill: ny «Start sesong»-knapp som genererer kampprogrammet for alle divisjoner med minst 2 par (rører aldri divisjoner som alt har spilte kamper). Vises automatisk når par er registrert men kampprogram mangler. Du kan nå også legge til en ny klasse (Herrer/Damer/Mix) i en serie som alt er i gang. Rettet en feil der demo-par ikke ga noe kampprogram/tabell: demospillerne ble ikke lagret til spiller-databasen, så parene ble forkastet ved lagring — nå opprettes de som ekte spillere med ELO.',
    sections: [
      {
        type: 'new',
        title: 'Seriespill: Start sesong & legg til klasse',
        items: [
          'Ny «Start sesong»-knapp i seriespill-visningen genererer kampprogram for alle divisjoner med minst 2 par. Banner vises når par finnes men kampprogram mangler.',
          'Trygt: divisjoner som allerede har kamper røres ikke (spilte resultater bevares).',
          'Legg til ny klasse (Herrer/Damer/Mix) i en pågående serie via «Legg til klasse»-knappene. Klassen starter tom og fylles via Innstillinger + Start sesong — påvirker ikke eksisterende klasser.',
          'Divisjonsfilteret har «Alle» (nå default) som viser alle divisjonenes tabeller og kampprogram stablet. Klassefilteret har også «Alle» som viser alle klassene (Herrer/Damer/Mix) gruppert.',
          'Demo-resultater (Padel24-stil) ligger nå i toolbaren: «Random (denne runden)» og «Random (hele turneringen)» med fremgangsteller. De respekterer filteret — er du på Damer fylles kun damer, er du på «Alle» fylles alt.',
          'Spillernavn er klikkbare i tabell og kampprogram → åpner en spiller-modal med resultater, kommende kamper og «Full profil» (samme oppsett som Padel24).',
          'Bytte ut skadet spiller fra spiller-modalen: innbytteren overtar parets resterende kamper, mens allerede spilte kamper beholder ELO hos den opprinnelige spilleren (kun fremtidige kamper påvirkes, som i Padel24).',
        ],
      },
      {
        type: 'bugs',
        title: 'Seriespill: demo-par ga tom serie',
        items: [
          'Demo-par opprettet spillere som ikke ble lagret i databasen, så parene ble forkastet ved lagring (ingen kamper/tabell). Demospillere opprettes nå som ekte spillere med id og ELO — gjelder både oppsett-wizardet og sesong-innstillinger.',
        ],
      },
      {
        type: 'design',
        title: 'Seriespill: opp-/nedrykk i tabellen',
        items: [
          'Tabellen er pusset opp i liga-stil: sammenhengende fargeskinne til venstre (grønn = opprykk, rød = nedrykk), diskret zebra-striping, rammet tabell og tydelige poeng. Tegnforklaring over tabellen. Øverste divisjon har ingen opprykk, nederste ingen nedrykk.',
        ],
      },
      {
        type: 'new',
        title: 'Seriespill: auto opp/nedrykk-policy',
        items: [
          'Opp/nedrykk justeres nå automatisk etter antall lag i divisjonen: ≤4 lag → 1, 5–9 → 2, 10+ → 3 (aldri flere enn divisjonen tåler).',
          'Auto er default per divisjon, men kan slås av i «Innstillinger for klassen» for å sette egne tall (Opprykk/Nedrykk). Tabellen viser om divisjonen er auto eller manuell.',
        ],
      },
      {
        type: 'new',
        title: 'Seriespill: spilleregler, ELO-vekt & kjønnslogikk',
        items: [
          'Hovedinnstillinger har nå serie-standard for kampformat (super-tiebreak / fullt 3. sett), tellemåte ved 40–40 (fordel / gullpoeng), mix-serveregel (dame↔dame), ELO-multiplikator og et hovednotat (fritekst).',
          'Reglene kan overstyres per klasse, og finjusteres videre per divisjon (arv / på / av). Hver divisjon kan ha sitt eget regel-notat.',
          'Divisjonens gjeldende regler vises som et eget «Regler»-felt i tabellen — formatet, tellemåten, mix-serve, ELO-vekt og notatene (serie + divisjon).',
          'Demospillere følger nå kjønn: Mix får 1 dame + 1 herre per par, Damer kun damer, Herrer kun herrer. Par-søket filtrerer likt — og i herreklassen kan man huke av for å også søke blant damer.',
        ],
      },
      {
        type: 'bugs',
        title: 'Seriespill: resultatinnleggelse krasjet',
        items: [
          'Resultat-modalen i divisjonspillets kampprogram krasjet fordi runde-nummeret ble behandlet som tekst. Rettet — den smarte poenginnleggelsen (samme som Klubbmesterskapet) virker nå i seriespillet.',
        ],
      },
    ],
  },
  {
    version: '1.15.1',
    name: 'Seriespill — intuitiv par-påmelding',
    pushedAt: '2026-06-04T16:00:00+02:00',
    date: 'juni 2026',
    summary:
      'Påmelding av par i Seriespill (divisjonspill) bruker nå samme intuitive grensesnitt som Klubbmesterskapet — både i oppsett-wizardet og i «Sesong-innstillinger» for en aktiv serie: tydelige «Spiller 1/2»-bokser, søkefelt med ELO-sortert klikkbar liste («Velg →») og ELO/kjønn-merker, samt «+ Ny spiller» rett i flyten. Divisjon-velgeren for nye par er beholdt. Nye demo-knapper «+ 5 par» og «+ 10 par» (oppretter friske demopar) begge steder; «Fyll opp» fra databasen er beholdt i wizardet. Seriespill har som før ingen harde kjønnsregler (alle spillere kan i alle klasser).',
    sections: [
      {
        type: 'design',
        title: 'Seriespill: par-påmelding',
        items: [
          'Ny spillervelger lik Klubbmesterskapet: «Spiller 1/2»-bokser, søk med ELO-sortert liste og «Velg →», ELO- og kjønnsmerker — i oppsett-wizardet OG i sesong-innstillinger for aktiv serie.',
          '«+ Ny spiller» ligger nå rett i søkeflyten og auto-velges i ledig slot.',
          'Standard divisjon for nye par beholdt; par kan fortsatt flyttes mellom divisjoner i listen.',
          'Demo-knapper «+ 5 par» og «+ 10 par» begge steder. I sesong-innstillinger kan du styre om demoparene legges i én valgt divisjon eller N par i HVER divisjon. «Fyll opp» fra databasen beholdt i wizardet.',
        ],
      },
    ],
  },
  {
    version: '1.15.0',
    name: 'PlayOS — booking, soner og serier',
    pushedAt: '2026-06-04T12:00:00+02:00',
    date: 'juni 2026',
    summary:
      'PLAYOS: Portalen heter nå PlayOS (turneringsformatet Padel24 består). Stor utbygging av booking/kalender: per-bane fasiliteter (single/dobbel, utløp, streaming) satt globalt eller overstyrt per bane med tri-state, kalendervisning med «nå»-strek, auto-scroll og låst bane-kolonne, åpningstid over midnatt, og fargekoding etter opphav (bruker/senter/turnering/gjentakende). Gjentakende bookinger er nå ekte serier med felles ID, «denne/hele serien»-valg, og batch-lagring så store serier ikke henger nettleseren. Prissoner har fått standardpris (med gratis-valg), valg om sonen erstatter eller legges på toppen av standardprisen, og helligdag-håndtering (ta med / hopp over / kun helligdager) med hurtigvisning av aktive helligdager. Slot-kort og booking-modal viser nå «Gratis» tydelig. Ny hjelpeside for booking. Demo: fyll seriespill med demopar, og fyll Padel24-finaler med random-resultater (to-klikks-flyt).',
    sections: [
      {
        type: 'new',
        title: 'PlayOS-navn og logo',
        items: [
          'Portalen og motoren heter nå PlayOS / PlayOS Engine. Turneringsformatet Padel24 er uendret.',
          'Ny logo (avrundet flate med play-trekant). Navnet styres fra én konstant (PORTAL_BRAND) for enkelt bytte senere.',
        ],
      },
      {
        type: 'new',
        title: 'Booking: fasiliteter, kalender og farger',
        items: [
          'Per-bane fasiliteter: single/dobbel, kan løpe ut, streaming — satt globalt eller overstyrt per bane (tri-state: arv/på/av).',
          'Kalendervisning (tidligere Bane-matrise) med rød «nå»-strek, auto-scroll til nå, og låst bane-kolonne ved horisontal scroll.',
          'Åpningstid over midnatt støttes (f.eks. 05:00–01:00).',
          'Fargekoding etter opphav: blå = bruker, lilla = senter/admin, oransje = turnering, grønn = gjentakende.',
        ],
      },
      {
        type: 'new',
        title: 'Gjentakende serier',
        items: [
          'Gjentakende bookinger får felles serie-ID og 🔁-ikon. Klikk på en serie gir valg om å endre/kansellere denne forekomsten eller hele serien.',
          'Redigering av hele serien kan også endre selve mønsteret (frekvens/intervall/ukedager/slutt).',
          'Store serier opprettes/slettes/endres i én batch — ingen henging.',
        ],
      },
      {
        type: 'new',
        title: 'Prissoner',
        items: [
          'Standardpris (grunnpris) for tid uten sone, med eget «Gratis»-valg.',
          'Per sone: erstatt standardprisen eller legg sonens pris i tillegg.',
          'Helligdager per sone: ta med / hopp over / kun helligdager, med hurtigvisning av aktive helligdager (NO/SE/DK).',
          '«Gratis» vises tydelig i slot-kort og booking-modal.',
        ],
      },
      {
        type: 'fix',
        title: 'Demo og finaler',
        items: [
          'Seriespill: knapp for å fylle en klasse med 10 demopar (oppretter spillere).',
          'Padel24: «Random (denne fase)» fyller siste fase; nytt klikk trekker og spiller finalene (to adskilte steg).',
          'Start-tidspunkt i ny booking ble blankt ved enkelte åpningstider — rettet.',
          '«Tøm»-knappen tømmer nå hele kalenderen (med bekreftelse).',
        ],
      },
    ],
  },
  {
    version: '1.14.0',
    name: 'Klubbmesterskap II',
    pushedAt: '2026-05-28T12:00:00+02:00',
    date: 'mai 2026',
    summary:
      'KLUBBMESTERSKAP II — BANEPAD, BANE-PRIORITERING OG MER: Klubbmesterskapet har fått en komplett banepad i mørk iPad-stil med game-for-game-registrering, ekte tiebreak og super-tiebreak, smart hurtigvelger, walkover (WO) med tidsstempel, samt angre/nullstill. Bane-prioriteringen er løftet inn i kalenderen som et utvidbart panel: stokk om baner etter reglene, angre utfallet, få en rapport over hva som ble flyttet, og to nye valg — «Tving beste baner» (la en bane stå tom for å få topp-kampen på beste ledige bane) og «Rangér de øverste N baner» (resten fordeles tilfeldig). ELO for klubbmesterskap regner nå «big win» game-basert (super-tiebreak teller lite). Spillere-fanen er bygget om til oversiktlige lag-kort med felles lag-ELO, meritter løfter klubbmesterskaps-pokaler tydeligere fram, og kalenderen viser sluttspill-runder med fullt navn og lar deg minimere dager. I tillegg: damer kan delta i herreklassen (eget valg), Mix krever alltid 1 dame + 1 herre, og en rekke feilrettinger.',
    sections: [
      {
        type: 'new',
        title: 'Banepad for klubbmesterskap',
        emoji: '📱',
        items: [
          {
            title: 'Banepad i mørk iPad-stil',
            description:
              'Klubbmesterskapet har fått samme banepad-opplevelse som Padel24 — én bane per kort, mørkt panel, aktiv kamp fremhevet i hvitt med score sentrert i midten og settstilling som «(1) 6–4 (0)». Lagene står på hver side med navn og snitt-ELO.',
          },
          {
            title: 'Game-for-game med tiebreak',
            description:
              'Registrer kampene game for game. Ved 6-6 går settet til ekte tiebreak (til 7, vinn med 2 → 7-6), og ved 1-1 i sett spilles super-tiebreak til 10. Smart hurtigvelger foreslår sannsynlige verdier, og lukkes ved klikk utenfor.',
          },
          {
            title: 'Walkover (WO) med tidsstempel',
            description:
              'Møter ikke et lag opp, registrerer du walkover direkte på banepaden. Knappen er alltid tilgjengelig (skjules når resultat er påbegynt) og advarer hvis kampen ikke har startet ennå. Tidspunktet WO ble registrert lagres og vises, vinnerlaget får hake og taperen merkes «møtte ikke». WO holdes utenfor ELO.',
          },
          {
            title: 'Angre og nullstill',
            description:
              'Angre-knapp tar tilbake siste innlegging, og nullstill har en to-trinns bekreftelse.',
          },
          {
            title: 'Tilpasset hjelpeside for spillerne',
            description:
              'En «Hjelp»-knapp i den startede turneringen åpner en forklaring som er tilpasset akkurat denne turneringens oppsett: grupper og videreføring, seeding/trekning, hva som skjer ved ujevne grupper, banepad-bruk, bane-prioritering, ELO og en Q&A til slutt.',
          },
        ],
      },
      {
        type: 'new',
        title: 'Bane-prioritering i kalenderen',
        emoji: '🔀',
        items: [
          {
            title: 'Utvidbart panel med omstokking',
            description:
              'Kalenderen har et eget bane-prioriteringspanel (klikk hvor som helst for å åpne). Der kan du stokke om banene etter reglene uten å endre tider, og en rapport viser nøyaktig hvilke kamper som ble flyttet (eller at ingenting endret seg).',
          },
          {
            title: 'Angre omstokking',
            description:
              'Liker du ikke resultatet, gjenoppretter «↶ Angre» både baner og regler slik de var rett før.',
          },
          {
            title: 'Tving beste baner',
            description:
              'Et valg som lar en dårligere bane stå tom om nødvendig, slik at den høyest prioriterte kampen får den beste ledige banen i tidsluken — nyttig når halvtimes-rotasjonen ellers hindrer at de beste spiller på hovedbanen.',
          },
          {
            title: 'Rangér kun de øverste banene',
            description:
              'Du kan velge at bare de N øverste banene «rangeres» (f.eks. kun hovedbanen), mens resten fordeles tilfeldig.',
          },
          {
            title: 'Ryddigere kalender',
            description:
              'Sluttspill-runder vises med fullt navn (Finale, Semifinale, …), dager kan minimeres, uplassert-feltet vises kun når det er i bruk, og «Vis baner»-filteret og bane-belastnings-feltet er fjernet.',
          },
        ],
      },
      {
        type: 'improvement',
        title: 'Spillere, meritter og rettferdig ELO',
        emoji: '🏆',
        items: [
          {
            title: 'Spillere som lag-kort',
            description:
              'Spillere-fanen i klubbmesterskap er bygget om til kompakte lag-kort — ett kort per par med begge spillerne og felles lag-ELO, med tydelige filtre på klasse og gruppe.',
          },
          {
            title: 'Klubbmesterskaps-pokaler løftes fram',
            description:
              'I meritter får klubbmesterskap størst visuell vekt, Padel24 middels og Americano minst. «Alle kamper» og «Meritter» har nå antall-tellere som «Turneringer».',
          },
          {
            title: '«Big win» regnes game-basert',
            description:
              'ELO for klubbmesterskap måler nå seiersmargin på games (som Padel24), ikke bare sett. Et super-tiebreak-sett teller lite, så en jevn 3-setter avgjort 10-0 i super-tiebreak gir ikke stor ELO-effekt.',
          },
        ],
      },
      {
        type: 'adjustments',
        title: 'Påmeldingsregler og oppsett',
        emoji: '⚙️',
        items: [
          {
            title: 'Damer kan delta i herreklassen',
            description:
              'Et eget «inkluder damer»-valg i påmeldingen lar damer spille i herreklassen (ikke motsatt). Damespillere dukker ikke opp automatisk siden det er et unntak.',
          },
          {
            title: 'Mix krever alltid 1 dame + 1 herre',
            description:
              'Også i Åpen klasse må mix-par bestå av én av hver. Åpen klasse betyr nå kun «ingen ABC-deling».',
          },
          {
            title: 'Fritt antall minutter per kamp',
            description:
              'Minutter per kamp (gruppespill og sluttspill) kan nå settes fritt — verdien justeres først når du forlater feltet.',
          },
        ],
      },
      {
        type: 'bugs',
        title: 'Feilrettinger',
        emoji: '🐛',
        items: [
          {
            title: 'Riktig navn på pausede/arkiverte klubbmesterskap',
            description:
              'Pausede og arkiverte klubbmesterskap viste «Turnering» i stedet for det valgte navnet. Navnet lagres nå riktig.',
          },
          {
            title: 'Riktig antall par i bracket-gruppene',
            description:
              'Forhåndsvisningens og resultatenes gruppekolonne kunne vise par fra andre klasser (gruppe-ID-kollisjon). Matchingen er nå divisjon-bevisst.',
          },
        ],
      },
    ],
  },
  {
    version: '1.13.0',
    name: 'Lucky Looser',
    pushedAt: '2026-05-27T12:00:00+02:00',
    date: 'mai 2026',
    summary:
      'NY FUNKSJON — LUCKY LOOSER: En valgfri innstilling for Padel24-turneringer som gir hver gruppes vinner en ekstra sjanse. Når Lucky Looser er aktiv, rykker vinneren av hver gruppe opp og spiller bronsefinalen (8.-plass) i gruppen over. Gruppens egne spillere på plass 8 og nedover skyves én plass ned, og sistemann rykker ned til 1.-plass i gruppen under. Påvirker kun finaletrekningen — ikke opp/ned mellom faser. Finalene viser tydelig med stige-ikon hvilke plasser som er Lucky Looser-veien, både før og etter at finalene er trukket. I tillegg: Oppsett-steg 5 er omdøpt til "Oppsummering" og viser nå alle valgte innstillinger; "Runder"-telleren tar med finalerunden; og kampplanen hopper automatisk til Finaler-fanen når turneringen er ferdigspilt.',
    sections: [
      {
        type: 'new',
        title: 'Lucky Looser',
        emoji: '🪜',
        items: [
          {
            title: 'Gruppevinneren får en ekstra sjanse',
            description:
              'Med Lucky Looser aktiv rykker hver gruppes vinner opp og spiller bronsefinalen (8.-plass) i gruppen over. Gruppens egne spillere på plass 8 og nedover skyves én plass ned (8→9, 9→10 ...), og sistemann rykker ned til 1.-plass i gruppen under. En kjede som gjør at gode prestasjoner i en lavere gruppe belønnes med spill mot sterkere motstand.',
          },
          {
            title: 'Påvirker kun finaletrekningen',
            description:
              'Lucky Looser endrer ingenting i opp/ned mellom faser — gruppespillet går som normalt. Omrokeringen skjer først når finalene trekkes. Øverste gruppe mister bare sistemann nedover; nederste gruppe mister bare vinneren oppover.',
          },
          {
            title: 'Tydelig visning med stige-ikon',
            description:
              'Finale-radene viser et stige-ikon (symbol for opprykk) ved plassen Lucky Looser-spilleren tar, og et merke i finale-headeren. Placeholderne viser riktig gruppe og plassering allerede før finalene er trukket — slik at arrangøren ser strukturen på forhånd.',
          },
          {
            title: 'Slås på i oppsettet',
            description:
              'Lucky Looser velges i wizardens grunnoppsett, under finale-innstillingene. En fremhevet seksjon med stige-ikon, grønn når aktiv. Innstillingen settes ved opprettelse av turneringen.',
          },
        ],
      },
      {
        type: 'improvement',
        title: 'Oppsett og kampplan',
        emoji: '📋',
        items: [
          {
            title: 'Steg 5 omdøpt til "Oppsummering"',
            description:
              'Det siste wizard-steget heter nå "Oppsummering" i stedet for "Start", og viser en komplett liste over alle valgte innstillinger: spillere per gruppe, opp/ned-antall, trekningsmodus, pacing, gruppe-rekkefølge, makker-mønster i finaler, Lucky Looser, ELO-vekt, baner og trekningsregler.',
          },
          {
            title: '"Runder" teller med finalerunden',
            description:
              'Statkortet "Runder" i kampplanen viste tidligere bare faserundene (2 per fase). Nå tas finalerunden med — en turnering med 4 faser viser 9 runder (8 faserunder + 1 finalerunde).',
          },
          {
            title: 'Hopper til Finaler automatisk',
            description:
              'Når turneringen er ferdigspilt (alle faser unna, finaler trukket), hopper kampplanen automatisk til Finaler-fanen i stedet for å bli stående på siste fase.',
          },
        ],
      },
    ],
  },
  {
    version: '1.12.0',
    name: 'Klubbmesterskap',
    pushedAt: '2026-05-18T16:00:00+02:00',
    date: 'mai 2026',
    summary:
      'NY TURNERINGSTYPE — KLUBBMESTERSKAP: Tradisjonell par-basert turnering med gruppespill og sluttspill, organisert som klassisk klubbmesterskap. Støtter flere kategorier i samme turneringspakke (Herrer, Damer, Mix) — hver kategori kan deles inn i klasser (A/B/C) basert på ferdighet. Mix-kategorien har valgfri "Åpen klasse" hvor det ikke kreves 1 dame + 1 herre per par. Wizard i 5 steg: Grunninfo → Banetilgang → Påmelding → Seeding → Forhåndsvisning. Snake-seeding fordeler styrken jevnt i grupper. Cross-over fra grupper til sluttspill følger FIP-standard (A1-B2/C1-D2-mønster). Sluttspill-diagram med finalen sentrert og semifinaler/kvartfinaler speilet på begge sider. Match-format default: best of 3 med super-tiebreak (FIP-standard). Banetids-budsjett sjekker at turneringen får plass i tilgjengelig kalender. MERK: Banepad-modul med score-input og kamp-rotasjon kommer i neste utviklings-økt — denne versjonen dekker oppsett og forhåndsvisning.',
    sections: [
      {
        type: 'new',
        title: 'Ny turneringstype: Klubbmesterskap',
        emoji: '🏆',
        items: [
          {
            title: 'Par-basert turnering med faste makkere',
            description:
              'I motsetning til Americano/Mexicano (rotasjon), spilles klubbmesterskap med faste makker-par gjennom hele turneringen. Hvert par melder seg på til én klasse, og spiller alle sine kamper sammen.',
          },
          {
            title: 'Flere kategorier i én pakke',
            description:
              'Én KM-turnering kan inneholde Herrer, Damer og Mix samtidig — delt banetid, delt kalender. Slik kan en helg arrangere klubbmesterskap i alle kategoriene parallelt.',
          },
          {
            title: 'Klasser A/B/C per kategori',
            description:
              'Hver kategori kan deles i 1-3 klasser etter ferdighet. For eksempel: "Herrer A" (16 sterkeste par), "Herrer B" (resten). Klassene har egne grupper og sluttspill, slik at nivå-jevne par møtes.',
          },
          {
            title: 'Mix kan være "Åpen klasse"',
            description:
              'Mix-kategorien har en toggle for "Åpen klasse" hvor det ikke kreves at hvert par har 1 dame + 1 herre. Da spilles én samlet klasse uten ABC-deling — enkelt format for blandede par på alle nivåer.',
          },
        ],
      },
      {
        type: 'new',
        title: 'Oppsett-wizard i 5 steg',
        emoji: '🧭',
        items: [
          {
            title: 'Steg 1 — Grunninfo',
            description:
              'Navn på turneringen, hvilke kategorier som skal med (Herrer/Damer/Mix), antall klasser per kategori (1-3 stk A/B/C), Mix Åpen-toggle, og standard match-format (best of 3 m/super-tiebreak som default).',
          },
          {
            title: 'Steg 2 — Banetilgang',
            description:
              'Antall baner, buffer mellom kamper (default 5 min), og en liste over spille-dager med dato + start-/sluttklokkeslett. Viser løpende beregning av total tilgjengelig banetid.',
          },
          {
            title: 'Steg 3 — Påmelding',
            description:
              'Registrer par per klasse. Spiller-velger filtrerer på kjønn der det kreves (Herrer = kun M, Damer = kun F, Mix = 1+1 unntatt i Åpen klasse). Brukte spillere fjernes automatisk fra listen. Krever minst 2 par per aktive klasse.',
          },
          {
            title: 'Steg 4 — Seeding',
            description:
              'Parene sorteres etter summert ELO som forslag. Drag-and-drop for å overstyre rekkefølgen manuelt. Live preview av snake-seedingen som viser hvordan parene fordeles i grupper (#1, #8, #9, #16 i samme gruppe ved 16-par/4-grupper).',
          },
          {
            title: 'Steg 5 — Forhåndsvisning',
            description:
              'Komplett oversikt før start: banetid-budsjett (passer / for tett), per klasse-oversikt med grupper og sluttspill-bracket. Når alt ser bra ut, klikk "🏆 Start turnering" for å lagre.',
          },
        ],
      },
      {
        type: 'new',
        title: 'Algoritmer og logikk',
        emoji: '🧮',
        items: [
          {
            title: 'Snake-seeding (serpentine)',
            description:
              '16 par i 4 grupper → A={1,8,9,16}, B={2,7,10,15}, C={3,6,11,14}, D={4,5,12,13}. Sikrer at hver gruppe har balansert sum av seed-tall, så ingen "death group" oppstår.',
          },
          {
            title: 'Round-robin gruppespill (Berger-tabellen)',
            description:
              'Alle par i en gruppe møter alle andre én gang. 4 par = 6 kamper, 5 par = 10 kamper, osv. Sett-resultater og settdiff brukes til rangering.',
          },
          {
            title: 'Cross-over til sluttspill',
            description:
              'Etter gruppespill går toppen til sluttspill med FIP-standard cross-over: A1-B2, C1-D2, B1-A2, D1-C2. Sikrer at gruppe-vinnere møtes tidligst i finale.',
          },
          {
            title: 'FIP-bracket-seeding (uten gruppespill)',
            description:
              'For klasser uten gruppespill: seed 1 i slot 1, seed 2 i siste slot. Seed 3 og 4 plasseres i motsatte kvartdeler. Støtter 4, 8, 16 og 32-pars-brackets.',
          },
          {
            title: 'Stillings-rangering',
            description:
              'Padel-standard: poeng → settdifferanse → game-differanse → innbyrdes oppgjør → original seed. 2-0-seier = 3 poeng, 2-1-seier = 2 poeng, 1-2-tap = 1 poeng, 0-2-tap = 0.',
          },
          {
            title: 'Banetids-budsjett',
            description:
              'Beregner totalt antall kamper × match-tid (60min gruppe / 75min sluttspill default) og sammenligner mot tilgjengelig banetid (dager × varighet × antall baner). Viser utilization-prosent.',
          },
        ],
      },
      {
        type: 'design',
        title: 'Sluttspill-diagram',
        emoji: '🎨',
        items: [
          {
            title: 'Finalen sentrert i bracket',
            description:
              'Tradisjonelle brackets tegnes med finalen ytterst til høyre. Klubbmesterskap-bracketen plasserer finalen i midten — semifinaler på begge sider, kvartfinaler ytterst. Gir en visuell konvergens mot toppkampen.',
          },
          {
            title: 'Match-bokser med vinner-markering',
            description:
              'Hver kamp vises som en kompakt boks med to lag-rader. Vinnerens rad får aksent-bakgrunn (rosa) og fet skrift når resultat er registrert.',
          },
          {
            title: 'Bronse-finale under hovedfinale',
            description:
              'Når bronse-finale arrangeres vises den rett under hovedfinalen, med bronsemedaljen-ikon for å skille den fra gull-kampen.',
          },
        ],
      },
      {
        type: 'tech',
        title: 'Tekniske detaljer',
        emoji: '⚙️',
        items: [
          {
            title: 'Padel24Engine.klubbmesterskap',
            description:
              'Hele engine eksponert som modul-objekt med snakeSeedGroups, roundRobinSchedule, buildCrossOverBracket, fipBracketSeed, calcGroupStandings, create() og calcBudget().',
          },
          {
            title: 'kMultiplier 1.5 for ELO',
            description:
              'Klubbmesterskap-kamper teller 1.5x i ELO-rating (versus 1.0x for Padel24 og 0.5x for Americano), siden de er lengre og mer betydningsfulle turneringer.',
          },
          {
            title: 'Storage-key klubbmesterskap_setups_v1',
            description:
              'Lagrede oppsett kan gjenbrukes for tilbakevendende turneringer (gjelder neste utviklings-økt).',
          },
          {
            title: 'Verifisert med Node-prototype',
            description:
              'Komplett simulering av KANG KM 2026 (32 herrer A+B + 16 damer + 16 mix par): 70 kamper totalt, 78% utilization over fred-søn helg med 4 baner. Snake-seeding, cross-over og FIP-bracket validert mot kjente testcases.',
          },
        ],
      },
      {
        type: 'fix',
        title: 'Begrensninger i denne versjonen',
        emoji: '⚠️',
        items: [
          {
            title: 'Banepad kommer i neste utviklings-økt',
            description:
              'Score-input, kamp-rotasjon, og klokkeslett-styring (à la Padel24) er ikke implementert ennå. Når en KM-turnering er opprettet vises gruppeoppsett, kamp-liste og sluttspill-diagram, men resultater kan ikke registreres.',
          },
          {
            title: 'Automatisk progresjon ikke ferdig',
            description:
              'Når gruppespill er ferdig genereres sluttspill-placeholders automatisk (A1 vs B2, osv.), men selve resultat-flyten som propagerer vinnere til neste runde (KF → SF → F) kommer i neste iterasjon.',
          },
          {
            title: 'Scheduling-algoritme placeholder',
            description:
              'Kamper plasseres ikke automatisk på time-slots ennå. Banetids-budsjett gir kun en aggregert sjekk — full kalender-fordeling kommer sammen med banepad.',
          },
        ],
      },
    ],
  },
  {
    version: '1.11.0',
    name: 'Familieformater',
    pushedAt: '2026-05-18T13:00:00+02:00',
    date: 'mai 2026',
    summary:
      'SEKS NYE TURNERINGSTYPER bygger ut hele mini-økosystemet med Mix-, Team- og Club-varianter: Mix Mexicano (kjønnsblanding), Team Mexicano (faste lag + stillings-basert), Mix Americano, Club Americano (to klubber), Club Team Americano (klubber + faste lag, round-robin), og Club Mexicano (klubber + best vs best). Nytt tennis-sett-modus med frys-modal når sett vinnes. Bingo-modus utvidet med frys ved fullt brett. Server-tennisball som SVG-ikon i match-header. Klubb-merker (logo + navn) i lederboardet. Mini-turneringsside redesignet med to-kolonne layout (Americano-familien venstre, Mexicano-familien høyre), ikon-filter (random/skill/team/mix/club), og kompakte kort som utvides med "Mer info"-knapp. Klubb-rang-basert finaler for Club-familien. Verifisert med Node-prototype før integrasjon.',
    sections: [
      {
        type: 'new',
        title: 'Nye turneringstyper',
        emoji: '🏆',
        items: [
          {
            title: 'Mix Mexicano (MMX)',
            description:
              'Mexicano med krav om kjønnsblanding — hvert lag består av én dame og én mann. Stillings-basert matchmaking, men kjønnsbalanse håndheves i hver kamp. Krever like mange damer og menn. Merke MMX (rosa-rød).',
          },
          {
            title: 'Team Mexicano (TMX)',
            description:
              'Team Americano med Mexicano-regler — faste makkerpar, men lagene matches stillings-basert (best mot nest best, osv.). Pool-størrelse 4/6/8 styrer variasjon i topp-banene. Merke TMX (lime-grønn).',
          },
          {
            title: 'Mix Americano (MAM)',
            description:
              'Americano med krav om kjønnsblanding — som Mix Mexicano, men med Americano-rotasjon (ikke stillings-basert). Merke MAM (oransje).',
          },
          {
            title: 'Club Americano (CAM)',
            description:
              'To klubber konkurrerer mot hverandre — hver bane har én spiller fra klubb A som makker med én fra klubb B, mot motsvarende par. Merke CAM (grønn). Finaler: klubb-rang-basert (A#1+A#2 vs B#1+B#2, osv.).',
          },
          {
            title: 'Club Team Americano (CTA)',
            description:
              'Two klubber med faste makkerpar (lag), round-robin mellom lag på tvers av klubber. Hvert A-lag møter alle B-lag minst én gang før gjentakelser. Merke CTA (teal-grønn).',
          },
          {
            title: 'Club Mexicano (CMX)',
            description:
              'Club Americano med Mexicano-regler — spillere rangeres innad i hver klubb, best fra A møter best fra B. Pool 4/6/8 styrer makker-variasjon innen klubben. Klubb-regel håndheves (aldri samme-klubb-makkere mot hverandre). Merke CMX (mørk blå).',
          },
        ],
      },
      {
        type: 'new',
        title: 'Spillemodi og runde-logikk',
        emoji: '⏱️',
        items: [
          {
            title: 'Tennis-sett-modus (first_set)',
            description:
              'Ny endMode="first_set" for Team Americano og Team Mexicano. Kamp slutter når et lag vinner et sett (6 spill, eller tie-break ved 6-6). Frys-modal dukker opp — kampen kan ikke fortsette i den runden. Settvinner og taper får konfigurerbare poeng.',
          },
          {
            title: 'Bingo-modus utvidet',
            description:
              'Frys-modal vises også når en spiller fyller bingo-brettet sitt. Konsistent visuell tilbakemelding på tvers av sett- og bingo-modus.',
          },
          {
            title: 'Server-rotasjon for Club-familien',
            description:
              'Tilfeldig start-server velges ved oppretting (lagret i config.initialServer). Veksler annenhver runde gjennom hele turneringen + finalene. Gjelder Club Americano, Club Team Americano og Club Mexicano.',
          },
        ],
      },
      {
        type: 'design',
        title: 'UI-forbedringer',
        emoji: '🎨',
        items: [
          {
            title: 'Server-tennisball som SVG',
            description:
              'Ny TennisBall-komponent: faktisk-ser-ut-som tennisball (gul fyllfarge, hvite buekurver for sømmen, lys-flekk for 3D-følelse). Vises i match-headeren ved siden av server-lagets navn. Erstatter den gamle emoji-tennisballen på lag-radene.',
          },
          {
            title: 'Klubb-navn i match-header',
            description:
              'Match-listen viser faktisk klubb-navn fra config.clubs i stedet for "Hjemmelag/Bortelag" for Club-familien. Klubb-fargestripe på match-radene (grønn=A, blå=B) for visuell skille.',
          },
          {
            title: 'Klubb-merker i lederboardet',
            description:
              'Spiller-rad har pille med klubblogo + klubbnavn ved siden av spiller-navn. Lag-rad (Club Team Americano) har pille på toppen for klubb-tilhørighet. Grønn pille for A, blå for B.',
          },
          {
            title: 'Mini-turneringsside: to-kolonne layout',
            description:
              'Americano-familien til venstre (vanlig → Team → Mix → Club → Club Team), Mexicano-familien til høyre (vanlig → Team → Mix → Club). Like store kort på samme rad. Plassholder hvis filteret tømmer en kolonne.',
          },
          {
            title: 'Ikon-filter på MiniTournamentsView',
            description:
              'Filter-knapper øverst: random / skill / team / mix / club. AND-logikk — kortet vises hvis ALLE valgte ikoner finnes på kortet. Hver filter-knapp viser antall kort som matcher.',
          },
          {
            title: 'Kompakte kort med "Mer info"-expand',
            description:
              'Default kompakt visning (kun ikon, navn, tagline). "Mer info ▾" / "Mindre ▴"-knapp utvider for full beskrivelse + features. "Vis all info" / "Skjul all info"-knapp i filter-headeren toggler alle synlige kort samtidig.',
          },
          {
            title: 'Lag-grupperinger i Step 2 (Club Team Americano)',
            description:
              'Påmeldt-liste viser lagene gruppert per klubb. "↔ Flytt klubb"-knapp per lag for å bytte tilhørighet uten å trekke spilleren.',
          },
        ],
      },
      {
        type: 'engine',
        title: 'Engine + arkitektur',
        emoji: '⚙️',
        items: [
          {
            title: 'Padel24Engine 1.10.0 "Familieformater"',
            description:
              'Nye engine-grener: buildMixHistory, generateMixicanoRound, buildTeamHistory, generateTeamMexicanoPool4/6/8Plan, buildClubPairs, calcClubStandings, buildClubTeamHistory, buildClubMexicanoPairs, og tilsvarende create/generateRound/generateFinals for hver type.',
          },
          {
            title: 'Klubb-rang-basert finaler',
            description:
              'generateClubAmericanoFinals / generateClubTeamAmericanoFinals / generateClubMexicanoFinals: A#1+A#2 vs B#1+B#2 (gull), A#3+A#4 vs B#3+B#4 (bronse), osv. ned. Finaler bevarer team1ClubId/team2ClubId.',
          },
          {
            title: 'calcClubStandings inkluderer finaler',
            description:
              'Tidligere ble finaler ekskludert fra totalsummen. Nå teller de med + ny finalsPlayed-teller for sporing.',
          },
          {
            title: 'Nye storage-nøkler',
            description:
              'mixicano_setups_v1, team_mexicano_setups_v1, mix_americano_setups_v1, club_americano_setups_v1, club_team_americano_setups_v1, club_mexicano_setups_v1 — alle separate fra Americano/Mexicano/Team Americano-oppsett.',
          },
        ],
      },
      {
        type: 'bugs',
        title: 'Feilrettinger',
        emoji: '🐛',
        items: [
          {
            title: 'handleStartFinals brukte alltid Americano-engine',
            description:
              'Padel24Engine.americano.generateFinals(tournament) ble alltid kalt. Nå brukes engineForRounds.generateFinals(tournament) (riktig engine per type). Påvirket alle Club-typer — finalene mistet klubb-tilhørighet.',
          },
          {
            title: 'isMexicanoFamily inkluderte ikke club_mexicano',
            description:
              'Settings-modalen manglet Mexicano-matchmaking-seksjon (pool, første runde, hver Nte runde) for Club Mexicano. Familie-flagget er utvidet.',
          },
          {
            title: 'clubMode is not defined i TournamentPlayerSelection',
            description:
              'clubMode ble brukt i komponenten uten å være en prop. Utledet nå fra tournamentType ved start av komponenten.',
          },
          {
            title: 'Sidebar for Club Team Americano ble overstyrt',
            description:
              'teamMode ? <TeamSidebar /> : <KlubSidebar /> — Club Team Americano har teamMode=true så klubb-sidebar-en vistes aldri. Fix: teamMode && !clubMode tar klubb først.',
          },
          {
            title: 'Pool 6 bug i Team Mexicano (10 lag)',
            description:
              't8 og t9 ble glemt etter while-loop i pool 6-plan. Lagt til remaining.length === 1 + restCarry-grein som plasserer dem riktig.',
          },
          {
            title: 'handleStart courts-clamping',
            description:
              'Hvis bruker konfigurerte flere baner enn det er plass til, krasjet engine. config.courts clampes nå til effectiveCourts (faktisk antall tilgjengelige).',
          },
        ],
      },
    ],
  },
  {
    version: '1.10.0',
    name: 'Mexicano',
    pushedAt: '2026-05-16T12:00:00+02:00',
    date: 'mai 2026',
    summary:
      'NY TURNERINGSTYPE: Mexicano — stillings-basert matchmaking der spillere møter andre rundt egen plassering. Pool-størrelse (4/6/8) kontrollerer hvor mye variasjon i topp-banene. Tre lag tilfeldighet (innledende runder, hver Nte runde, manuell knapp) bryter opp spiller-loops. Algoritmen prefererer K2 (1+3 vs 2+4), så K3 (1+4 vs 2+3) for å unngå makker-repetisjon. Gjenbruker Americano-UI med mexicanoMode-flag. Egen hjelpefil med matchmaking-forklaring. Verifisert med standalone Node-prototype før integrasjon: pool 6 gir 86 unike makkerpar mot 71 for pool 4 i 16sp/4b/12r-test.',
    sections: [
      {
        type: 'new',
        title: 'Mexicano-format',
        emoji: '🥇',
        items: [
          {
            title: 'Stillings-basert matchmaking',
            description:
              'Etter første runde sorteres spillerne på poeng. Bane 1 = topp 4, bane 2 = 5.-8. plass, osv. Gjør at sterke spillere møter sterke og svake møter svake — alle får jevnbyrdige kamper.',
          },
          {
            title: 'Pool-størrelse (variasjon)',
            description:
              'Lav (4) = klassisk Mexicano, samme topp-4 alltid på bane 1. Middels (6, default) = bane 1 velger 4 av topp-6 ut fra minst makker-repetisjon. Høy (8) = bane 1 velger 4 av topp-8, maks variasjon men 7.-8. plass kan ende på bane 1.',
          },
          {
            title: 'Tre lag tilfeldighet',
            description:
              'Innledende runder (0-3, default 1), hver Nte runde tilfeldig (av/3/4/5), og "Tilfeldig runde nå"-knapp under spill. Bryter spiller-loops uten å miste mexicano-formatets nivå-fokus.',
          },
          {
            title: 'Par-konstellasjon',
            description:
              'Innenfor 4 spillere [A,B,C,D] prøver algoritmen K2 (1+3 vs 2+4) først, så K3 (1+4 vs 2+3) hvis makkerparene har spilt sammen før. K1 (1+2 vs 3+4) brukes kun som siste utvei (skjev kamp).',
          },
          {
            title: 'Egne lagrede oppsett',
            description:
              'Mexicano-oppsett lagres i mexicano_setups_v1, helt separat fra Americano-oppsett. Lyser opp på Home-skjermen med oransje MX-merke.',
          },
          {
            title: 'Hjelpefil med matchmaking-forklaring',
            description:
              'Ny seksjon i hjelpemenyen med oversikt, pool-størrelse, par-konstellasjon, tilfeldige runder, og sittover-rotasjon.',
          },
        ],
      },
      {
        type: 'tech',
        title: 'Engine + arkitektur',
        emoji: '🔧',
        items: [
          {
            title: 'Padel24Engine.mexicano',
            description:
              'Eget API med create / generateRound / generateFinals / calcStandings / buildHistory / fillPlaceholder / replacePlayer. Finals, standings og historikk gjenbrukes fra Americano (samme datastruktur).',
          },
          {
            title: 'Gjenbruk av AmericanoSetupView og AmericanoView',
            description:
              'Begge komponentene aksepterer mexicanoMode/type-flag og rendrer mexicano-spesifikke felter (pool, random) og UI (MX-merke, oransje aksent, Tilfeldig-knapp). Sparer ~2000 linjer duplisering.',
          },
          {
            title: 'Verifisert med standalone prototype',
            description:
              'Ekstrahert engine-funksjoner og kjørt simulering med ELO-baserte resultater. Pool 4 ga 71 unike makkerpar (max rep 3); Pool 6 ga 86 (max rep 2); Pool 8 ga 93 (max rep 2). Test bevarte at randomFirstRounds, randomEveryNthRound og forceRandom fungerer som spesifisert.',
          },
        ],
      },
    ],
  },
  {
    version: '1.9.0',
    name: 'Setups & flyt',
    pushedAt: '2026-05-15T22:00:00+02:00',
    date: 'mai 2026',
    summary:
      'Padel24-formatet har fått drastiske endringer: faste spillertall-presets (48-192 spillere), 12 sp/gruppe, 4 opp/ned, låst format-card med "Endre"-knapp, dynamic scheduling-algoritme, banealternativer-tabell med rotasjons-brøk og HH:MM-tid. Setups-system erstatter auto-save: lagre hele wizard-state med navn, lyse-opp-knapp ved ulagrede endringer, fri steg-navigasjon. Finale-fixes (gull til slutt), bug-tracking-overhaul med statuser og kommentarer, og browser back-knapp.',
    sections: [
      {
        type: 'new',
        title: 'Padel24 — drastiske endringer',
        emoji: '🎾',
        items: [
          {
            title: 'Faste spillertall-presets',
            description:
              '10 presets: 48, 60, 72, 84, 96, 120, 132, 156, 168, 192 spillere. Hver preset har faste 12 spillere per gruppe og minimum antall baner.',
          },
          {
            title: 'Låst turneringsformat-card',
            description:
              'Faser, finale, opp-/nedrykk, gruppestørrelse, drawing mode, pacing er gråe/disabled som standard. LockedField-wrapper viser "Endre"/"Lås"-knapp.',
          },
          {
            title: 'Padel24-standardverdier låst',
            description:
              '12 sp/gruppe · 4 faser + finaler · Opp/ned = 4 (33%) · Kamplengde 27/25 min · 5 min mellom kamper · Fre 16-23 / Lør 9-17 · Pacing one_gap + dynamic phase start · Finals pairing 1+3 vs 2+4',
          },
          {
            title: 'Dynamic scheduling-algoritme',
            description:
              'Ny pacingMode + phaseStartMode-separasjon. Par fra ulike faser/grupper kan blandes i samme slot for å fylle hull. Verifisert: 60 sp / 5 grupper / 5 baner gir 100% banebruk, ferdig lør 15:00.',
          },
        ],
      },
      {
        type: 'tech',
        title: 'Finale-fixes',
        emoji: '🏆',
        items: [
          {
            title: 'Finale 1 (gull) plasseres SIST',
            description:
              'Ikke en tilfeldig midten-finale. Hvis det er flere finaler enn baner, havner Finale 1 alene i siste runde for rampelys.',
          },
          {
            title: 'Finale-overlapp fikset',
            description:
              'Finaler ble plassert FØR applyPacingMode som forskjøv fase-tidene. Nå plasseres finaler ETTER, med beregning av maks slutt-tid per dag.',
          },
          {
            title: 'Per-group finals resolving',
            description: 'Finalene refererer riktige spillere fra hver gruppe etter siste fase.',
          },
        ],
      },
      {
        type: 'tech',
        title: 'Bug-tracking & broken-tournament guards',
        emoji: '🔧',
        items: [
          {
            title: 'Bug-rapport-statuser og kommentarer',
            description:
              'Statuser: åpen, i arbeid, fikset, lukket. Kommentarer på hver rapport, bedre filter og oversikt.',
          },
          {
            title: 'Korrupte turneringer-håndtering',
            description:
              'Guards mot data uten matches/groups slik at appen ikke krasjer på gamle eller skadede turnerings-data.',
          },
          {
            title: 'Browser back-knapp',
            description:
              'Hash-routing slik at browserens tilbake-knapp navigerer mellom appens views i stedet for å gå ut av siden.',
          },
        ],
      },
      {
        type: 'new',
        title: 'Setups & arbeidsflyt',
        emoji: '✨',
        items: [
          {
            title: 'Lagrede oppsett (setups-system)',
            description:
              'Lagre hele wizard-state som et navngitt oppsett — config, spillere, ELO-overstyringer, gruppeinndeling og låste spillere. Klikk 💾-knappen på et hvilket som helst steg for å lagre med turneringsnavnet. Velg fra "Last oppsett…"-dropdown for å gjenbruke. Auto-save av draft er fjernet — ny turnering starter alltid friskt.',
          },
          {
            title: 'Lagrede oppsett-card på Home',
            description:
              'Startsiden viser alle lagrede oppsett fra alle formater (Padel24, Americano, Team Americano). Klikk et oppsett for å starte ny turnering basert på det — hopper rett til siste relevante steg (3 hvis grupper finnes, 2 hvis kun spillere er valgt).',
          },
          {
            title: 'Lagre-knapp lyser opp ved ulagrede endringer',
            description:
              'Knappen har 3 visuelle tilstander: grå (ingenting å lagre), lime-deep med bakgrunn (ulagrede endringer), grønn check (nettopp lagret). Dirty-tracking via snapshot-sammenligning.',
          },
          {
            title: 'Fri steg-navigasjon i wizarden',
            description:
              'Alle steg er nå klikkbare så lenge forutsetningene er oppfylt — ikke kun "tilbake til besøkte steg". Hvis du endrer noe som invaliderer et senere steg, låses det inntil det er gyldig igjen.',
          },
          {
            title: 'Slett-funksjon for lagrede oppsett',
            description:
              'Inline-bekreftelse i dropdown ELLER på Home-cardet (orange bakgrunn, rød Slett-knapp + Avbryt). Bruker ikke window.confirm() — fungerer ikke i Claude-iframe.',
          },
        ],
      },
      {
        type: 'tech',
        title: 'Forbedringer',
        emoji: '🔧',
        items: [
          {
            title: 'Banealternativer-tabell med 4 kolonner',
            description:
              'Baner | Beskrivelse | Rotasjon | Dag 1 | Dag 2 — med faste bredder så layout ikke kollapser på smale skjermer. Rotasjon viser andel spillere på banen samtidig som forenklet brøk (1/3, 2/3, 7/15, etc.) via GCD.',
          },
          {
            title: 'Nye preset-navn',
            description:
              'Standard / Romslig / Effektiv / Komprimert / Alle samtidig — erstatter Minimum / Komfortabel / Kort / Veldig kort.',
          },
          {
            title: 'HH:MM-tidsformat i banealternativer',
            description:
              '04:45 og 07:00 i stedet for 4¾t — bedre lesbarhet og lik bredde i kolonnene.',
          },
          {
            title: 'Lås på turneringsformat-cardet',
            description:
              'LockedField-wrapper med "Endre/Lås"-knapp. Alle preset-felter (faser, finale, opp/ned, grupper, drawing mode, pacing) gråes ut og er ikke klikkbare som standard. Dager-cardet er alltid åpent (datoer, klokkeslett og pauser fritt redigerbare).',
          },
          {
            title: 'applyPreset resetter ALT',
            description:
              'Når brukeren velger preset (48p, 60p, 72p, …) resettes alle standard-felter: faser=4, finale=ja, opp/ned=4 (33% av 12), pacing=one_gap, phaseStart=dynamic, matchDuration 27/25, dager 16-23 / 9-17, baner=preset.minCourts. Bevarer bare turneringsnavn og datoer.',
          },
        ],
      },
      {
        type: 'bugs',
        title: 'Feilrettinger',
        emoji: '🐛',
        items: [
          {
            title: 'React #310 i Step3Groups og Step4Matches',
            description:
              'useMemo-kall etter early return brøt hooks-regler. Hooks flyttet før early return — bruker safeMatches = matches || [] i Step4.',
          },
          {
            title: 'React #300 ved lasting av oppsett',
            description:
              'Reset-effekt slettet lastede grupper umiddelbart. Lagt til skipResetRef som hopper over reset rett etter lasting.',
          },
          {
            title: 'React #300 fra auto-regen-loop',
            description:
              'config og schedule i useEffect-deps var nye objekter hver render. Strammet til primitive verdier (proposedGroups?.length, selectedPlayers.length).',
          },
          {
            title: 'Slett-knapp usynlig',
            description:
              'bg-rose finnes ikke som klasse (kun bg-rose-soft). Bruker nå inline style={{ background: var(--rose) }}.',
          },
        ],
      },
      {
        type: 'engine',
        title: 'Engine',
        emoji: '⚙️',
        items: [
          {
            title: 'Engine 1.8.1 "Setups & flyt"',
            description:
              'Patch-versjon. Ingen ELO-endringer. Finale-scheduling fikset (overflow til siste runde, gull alene). Dynamic packing-algoritme implementert (par fra ulike faser/grupper blandes for å fylle hull). Broken-tournament guards. previewMatches resettes på flere strukturelle config-endringer. applyPreset resetter nå ALLE Padel24-standard-felter.',
          },
        ],
      },
    ],
  },
  {
    version: '1.8.0',
    name: 'Team Americano',
    pushedAt: '2026-05-14T23:30:00+02:00',
    date: 'mai 2026',
    summary:
      'Ny turneringstype: Team Americano. Spillerne danner faste makkerpar som bevares gjennom hele turneringen — ingen rotasjon av lag. Hvert lag møter alle andre lag (når kapasitet tillater), og standings beregnes per lag. Sittover-logikken jevner ut hvilke lag som spiller mest. Finalene spilles 1.lag mot 2.lag (gull), 3. mot 4. (bronse), og så videre.',
    sections: [
      {
        type: 'new',
        title: 'Nytt',
        emoji: '✨',
        items: [
          {
            title: 'Team Americano-format',
            description:
              'Faste makkerpar gjennom hele turneringen. Velg spillere i steg 2, og parene dannes automatisk: 1+2 = Lag 1, 3+4 = Lag 2, osv. Krever et antall delelig på 4. Visuell oversikt over lagene mens du velger.',
          },
          {
            title: 'Lag-rangering i standings',
            description:
              'Lederboard viser én rad per lag (begge spillere stablet) istedenfor to separate rader. Lag-rangering er 1, 2, 3, 4 — ikke 1, 1, 3, 3.',
          },
          {
            title: 'Sittover-balansering per lag',
            description:
              'Når antall aktive lag overstiger banekapasiteten, sitter hele lag over. Engine velger lagene som har sittet over minst, slik at totalbelastningen jevnes ut.',
          },
          {
            title: 'Tilpasset sluttspill for Team Americano',
            description:
              'Finalene parres naborangering: 1.lag mot 2.lag (gull), 3. mot 4. (bronse), osv. "Hvordan settes finalelagene sammen?" utgår — parene er faste.',
          },
        ],
      },
      {
        type: 'engine',
        title: 'Engine',
        emoji: '⚙️',
        items: [
          {
            title: 'Engine 1.8.0 "Team Americano"',
            description:
              'Ny config.teamMode + config.teams på americano-turneringer. generateTeamAmericanoRound bevarer par i hver kvartett. calcAmericanoStandings omregner rank som lag-rang etter sortering. generateTeamAmericanoFinals parres nabo-mot-nabo. buildTeamHistory + selectBenchedTeams tracker sittover per lag.',
          },
        ],
      },
    ],
  },
  {
    version: '1.7.0',
    name: 'Hjelp og ny spiller-boost',
    pushedAt: '2026-05-14T22:00:00+02:00',
    date: 'mai 2026',
    summary:
      'En stor oppussing av ELO-systemet for å gjøre nye spillere raskere etablert. Lineær avtak med grace-periode istedenfor binær terskel: full 2x boost de første 5 kampene, så lineær avtak til 1x ved kamp 20. Drag-and-drop rangerings-konfigurasjon i både Padel24 og Americano — samme grensesnitt for begge formater. Engine-doc er ryddet, og en ny hjelp-side dekker turneringsformatene. Søkefelt i kamplaner med spillernavn-highlight. Kampdetaljer for enkeltkamper viser nå ELO-beregningen steg for steg.',
    sections: [
      {
        type: 'new',
        title: 'Nytt',
        emoji: '✨',
        items: [
          {
            title: 'Drag-and-drop rangering i begge oppsett',
            emoji: '🏆',
            description:
              'Padel24 og Americano har nå samme grensesnitt for å konfigurere rangerings-rekkefølge. Dra de fire kriteriene (seire, games/poeng-diff, innbyrdes, vunne games/poeng) til ønsket prioritet, og slå av kriterier som ikke skal brukes. Default-rekkefølge bevares ved "Tilbakestill". Engine respekterer konfigurasjonen ved opprykk/nedrykk og sluttrangering.',
          },
          {
            title: 'Lineær ny spiller-boost med grace-periode',
            emoji: '🔰',
            description:
              'Spillere med færre enn 20 fullførte kamper får forhøyet ELO-utslag. Full 2x boost de første 5 kampene (grace-periode), deretter lineær avtak til 1x ved kamp 20. Effektiv terskel skaleres med turneringens ELO-vekt — americano (50%) gir 40 kamper grace. Asymmetrisk: bare laget med ny spiller får boost.',
          },
          {
            title: 'Hjelp-side per turneringsformat',
            emoji: '📘',
            description:
              'Ny dedikert hjelp-side med utfyllende forklaringer av både Padel24 og Americano. Inkluderer SVG-diagrammer av faser, grupper, opp-/nedrykk, finaler og rotasjon. Sidebar lar deg bytte mellom formater. Tilgjengelig fra hjelp-knapp i wizard-toppen, americano-oppsett, og pågående turneringer.',
          },
          {
            title: 'Søkefelt i kamplaner med spillernavn-highlight',
            emoji: '🔍',
            description:
              'Padel24 Full kampplan og Americano kampoversikt har nå et søkefelt som filtrerer kamper til kun de hvor matchet spiller deltar. Matchende spillernavn vises med gul bakgrunn for rask visuell identifikasjon.',
          },
          {
            title: 'ELO-beregning vises i enkeltkamp-detaljer',
            emoji: '📈',
            description:
              'Kampdetalj-modalen for enkeltkamper viser nå hvordan ELO-endringen ble beregnet, steg for steg: forventet utfall, faktisk resultat, basis-endring (uten boost), ny-spiller-multiplikator, og endelig endring. Gir innsikt i hvordan K-faktor, MOV og boost kombineres.',
          },
          {
            title: 'Justerbare engine-innstillinger',
            emoji: '⚙️',
            description:
              'Tuning-seksjonen lar deg justere K-faktor, terskel for ny spiller, grace-periode (nytt), maks-boost, MOV-bonus og inaktivitetsdager. Endringer påvirker fremtidige kamper.',
          },
        ],
      },
      {
        type: 'engine',
        title: 'Engine',
        emoji: '⚙️',
        items: [
          {
            title: 'Engine 1.7.0 "Justerbar motor"',
            description:
              'K-faktor senket fra 64 til 32 (justerbar 8-64). Ny spiller-boost er nå lineær med grace-periode (justerbar terskel, grace, K-multiplier, inaktivitetsdager). compareForRanking og calcAmericanoStandings tar nå rankingOrder-array for konfigurerbar prioritering. matchesPlayed og lastMatchAt trackes automatisk. t1NewbieMul/t2NewbieMul lagres på enkeltkamper for korrekt visning av basis-tall. Migrering ved oppstart fyller gamle kamper.',
          },
        ],
      },
      {
        type: 'design',
        title: 'Designforbedringer',
        emoji: '🎨',
        items: [
          {
            title: 'Basis-tall i lag-pille, faktisk endring bak spillernavn',
            description:
              'Lag-ELO-cellen viser den "rene" endringen (uten boost) — slik at man ser hvor mye kampen "egentlig" var verdt. Spillerens 2x-pille viser den faktisk lagrede endringen. Gjelder UniversalMatchRow, PlayerMatchRow, PlayerSingleMatchRow og enkeltkamp-listen.',
          },
          {
            title: 'Kompakt boost-formatering: "2x" istedenfor "2.00x"',
            description:
              'Heltall vises uten desimaler. Sparer plass i alle visninger med boost-multiplikator: spillerprofil-badge, 2x-pille bak navn, kampdetaljer.',
          },
          {
            title: '"Nybegynner" → "ny spiller" i UI',
            description:
              'Terminologi-endring for å unngå forveksling med ELO-Nivå 1 ("Nybegynner"). Boost-systemet handler om antall spilte kamper, ikke ferdighetsnivå.',
          },
          {
            title: 'Forenklet søkefelt-layout',
            description:
              'Søkefeltet i kamplaner har nå flex-basert layout istedenfor absolute positioning. Tydeligere ramme og mer responsivt. Conditional rendering bruker length > 0 for å unngå "0"-rendering-bug.',
          },
        ],
      },
      {
        type: 'bugs',
        title: 'Feilrettinger',
        emoji: '🐛',
        items: [
          {
            title: '2x-badge mangler i PlayerSingleMatchRow',
            description:
              'Enkeltkamp-rader i spillerprofilen viste ikke ny spiller-boost. Lagt til badge-rendering med faktisk lag-endring bak.',
          },
          {
            title: 't1NewbieMul/t2NewbieMul ikke lagret på enkeltkamper',
            description:
              'Verdiene ble regnet ut, men aldri lagret på match.result. Førte til at "basis"-tall i lag-pille feilaktig viste boostet tall. Lagt til lagring i addSingleMatch/updateSingleMatch, og migrering reverse-engineer verdiene for gamle kamper.',
          },
          {
            title: 'Aktive turneringer vises nå i spillerprofil',
            description:
              'Spiller-historikk inkluderer pågående og pausede turneringer, ikke bare arkiverte. matchesPlayed og lastMatchAt aggregeres fra aktive turneringer i liveAllPlayers.',
          },
          {
            title: 'Demo-spillere er ikke lenger nye spillere',
            description:
              'PLAYER_DB-spillere får default matchesPlayed=30-130 ved oppstart, så demo-turneringer ikke gir 2x boost på alle spillerne.',
          },
        ],
      },
    ],
  },
  {
    version: '1.6.0',
    name: 'Banepad og innbyrdes',
    pushedAt: '2026-05-14T12:00:00+02:00',
    date: 'mai 2026',
    summary:
      'Banepadene styres nå smartere — Padel24 roterer som default etter resultat-innlegging, men kan settes til klokke-styrt rotasjon per turnering eller per enkelt bane. Auto-fløyte ("Varsel") blåser kamp i gang og av, og pauser vises stort i hver bane-feed med skip-knapp. Americano-oppsettet er ryddet kraftig (Poeng vs Games), fått fullskjerm-klokke med cooldown, valgbar alarm-lyd og stemme-varsler, og innbyrdes oppgjør kan nå brukes som tiebreak. Klubbene har egen identitet med logo og innstillinger, mobil viser match-tabeller med horisontal scroll, og bug-rapporter kan inkludere skjermbilder.',
    sections: [
      {
        type: 'new',
        title: 'Nytt',
        emoji: '✨',
        items: [
          {
            title: 'Banepad — "Roter etter"-valg per turnering OG per bane',
            emoji: '📱',
            description:
              'Padel24 har nytt config-felt padFlowMode (default "Resultat"). Velg om banepadene roterer umiddelbart etter resultat-innlegging, eller venter til neste kamps starttid. Hver bane har dropdown øverst som overstyrer turneringens default — huskes per iPad via localStorage.',
          },
          {
            title: 'Varsel — banedommer-fløyte ved kamp-start og slutt',
            emoji: '🏟️',
            description:
              'Hver banepad har "Varsel"-knapp som blåser fotball-dommer-fløyte automatisk når kamper starter og slutter. PÅ som default for nye baner. Lyden er en realistisk pea-whistle med trille (2 korte + 1 lang). Stoppes hvis Varsel slås av — huskes per bane.',
          },
          {
            title: 'Pauser vises stort i banepad-feeden',
            emoji: '☕',
            description:
              'Pauser flettes inn i hver banes match-feed kronologisk. Aktive pauser får stor gul gradient med nedteller "X min igjen". Ved Roter etter Resultat popper pausen opp stort også når banen er klar for pause — admin kan klikke "Avslutt pausevisning" for å gå rett til neste kamp. Pausens timer fortsetter i bakgrunnen og varsler ved pause-slutt.',
          },
          {
            title: 'Fullskjerm kamp-klokke for Americano Tids-modus',
            emoji: '⏰',
            description:
              'Ny knapp "Start klokke" i runde-headeren ved Tids-modus åpner stor klokke som dekker hele skjermen. Cooldown-fase (default 60 sek) før kamptiden begynner å tikke. Stort tids-display synlig fra avstand, fargeskifte ved siste minutt og 30 sek, wake-lock holder skjermen våken.',
          },
          {
            title: 'Valgbar alarm-lyd ved kampslutt',
            emoji: '🚨',
            description:
              'Fem lyder å velge mellom: Alarm (default), Sirene, Klokke, Fløyte, Pip. Alle generert med Web Audio API, ingen filer å laste. Eget Test-knapp for forhåndsvisning. Lyden spilles i loop ved kampslutt til admin klikker "Stopp alarm".',
          },
          {
            title: 'Stemme-varsler underveis i Americano-kamper',
            emoji: '🗣️',
            description:
              'Nettleseren sier "5 minutes remaining" og "Time\'s up" høyt under kampen. Hvert tidspunkt kan slås individuelt på/av (5 min, 4 min, 3 min, 2 min, 1 min, 30 sek, Time\'s up). Default: 5 min + Time\'s up. Test-knapp for forhåndsvisning.',
          },
          {
            title: 'Innbyrdes oppgjør som tiebreak i Americano',
            emoji: '⚔️',
            description:
              'Når to spillere er likt på poeng og seire, kan deres direkte oppgjør (h2h) brytes likheten. Plassering velges fritt: Av, Før poengdiff, Etter poengdiff, eller Etter poeng. Rekkefølge-strengen oppdaterer seg dynamisk i UI så brukeren ser nøyaktig hvordan rangering utføres.',
          },
          {
            title: 'Klubb-innstillinger med logo og kontaktinfo',
            emoji: '🏢',
            description:
              'Eget oppsett for klubbidentitet: navn, logo (med automatisk resize til 256x256 PNG), antall baner, adresse, telefon. Brukes som default for nye turneringer og vises i wizard og banepad-headere. Tilgjengelig via klubb-knapp i sidemenyen.',
          },
          {
            title: 'Bug-rapporter med skjermbilde',
            emoji: '📎',
            description:
              'Brukere kan legge ved skjermbilde i bug-rapporter. Tre måter: last opp fra disk, ta automatisk skjermbilde av nettleser-vinduet (getDisplayMedia API), eller lim inn med Ctrl+V. Bilder resizes til maks 1280px JPEG. Vises som thumbnails i bug-arkivet.',
          },
        ],
      },
      {
        type: 'design',
        title: 'Designforbedringer',
        emoji: '🎨',
        items: [
          {
            title: 'Forenklet Americano-poengsystem',
            description:
              'To primær-valg: Poeng eller Games. Under Poeng er det kun ett valg — antall poeng per kamp (default 24). Under Games velger man Bingo (default 5 games) eller Tid (default 15 min). Race-modus er fjernet helt, "Sett & games" likeså. Færre valg, klarere flyt.',
          },
          {
            title: 'Hjem-knapp åpner Padel24-wizarden direkte',
            description:
              'Den store grønne knappen "Opprett Padel24-turnering" på startsiden hopper nå rett inn i 5-stegs-wizarden, ingen mellomliggende kategori-skjerm. Andre formater (Americano, enkeltkamp) er fortsatt nåbart via menyen og "Andre oppsett"-knappen.',
          },
          {
            title: 'Mobile match-tabeller scroller sidelengs',
            description:
              'På mobil viser UniversalMatchRow og dets header nå minimumsbredde 680px og minmax-spillerkolonner. Wrappers er overflow-x-auto så brukeren kan swipe horisontalt for å se hele tabellen istedenfor at kolonner krympes til ulesbarhet.',
          },
          {
            title: 'Rangering innen gruppe synlig i Padel24-oppsett',
            description:
              'Wizard Step 1 har ny info-seksjon som viser nøyaktig hvilken rekkefølge spillere rangeres i mellom faser: 1) Antall seire, 2) Games-differanse, 3) Innbyrdes oppgjør, 4) Antall vunne games. Nummererte trinn med lime-pillar.',
          },
          {
            title: 'Dato i wizard auto-utleder ukedag',
            description:
              'Når brukeren velger dato på en turneringsdag, oppdateres dag-label automatisk til riktig ukedag (Fredag, Lørdag, osv.) hvis label fortsatt er standard. Custom-labels beholdes uforstyrret.',
          },
          {
            title: 'Banepad: "NESTE KAMP"-blokk når banen venter',
            description:
              'I tids-modus mellom kamper viser banepad nå en mørk blokk med stor lim-grønn starttid og "OM X MIN"-teller, istedenfor å hoppe direkte til neste kamp. Spillere ser tydelig hva som kommer og når.',
          },
          {
            title: 'Hjem-knapper, sidemeny og menyrydding',
            description:
              '"+ Opprett turnering" gir nå en kategori-velger (Padel24/Klubbmesterskap/Miniturneringer/Enkeltkamp). Bug-rapport-fanen er fjernet fra hovedmenyen — tilgjengelig via flytende knapp nederst til høyre med rød/grønn-badge for antall ulest. Klikk utenfor hamburger-meny lukker den automatisk.',
          },
        ],
      },
      {
        type: 'engine',
        title: 'Engine-oppdatering',
        emoji: '⚙️',
        items: [
          {
            title: 'Padel24 Engine 1.6.0 "Banepad og innbyrdes"',
            description:
              'h2hPosition-config i Americano-engine, padFlowMode for banepad-rotasjon, ELO-rollback ved sletting av Americano-runde med automatisk runde-renummerering, race-modus fjernet, alle nye config-felter for fullscreen-timer (cooldownSeconds, endSound, cooldownEndSound, voiceWarnings). Se engine-changelog for detaljer.',
          },
        ],
      },
      {
        type: 'bugs',
        title: 'Feilrettinger',
        emoji: '🐛',
        items: [
          {
            title: 'Padel24-wizard krasjet ved oppstart',
            description:
              'Step1Setup-komponenten manglet club-prop etter klubb-systemet ble innført, og krasjet med ReferenceError ved render. Nå mottas club korrekt som prop — logo og klubbnavn vises i arrangør-cardet.',
          },
          {
            title: 'Banepad hoppet til neste kamp før dens starttid',
            description:
              'Når flowMode er Tid: pågående-statusen utløses kun hvis kampens starttid faktisk har passert (med 1 min toleranse). Tidligere ble neste ikke-ferdige kamp automatisk "pågående" så snart admin la inn resultat — selv om klokken viste flere minutter til neste kamp skulle begynne.',
          },
          {
            title: 'Stemme og alarm overlappet ved kampslutt',
            description:
              'Tidligere ble "Time\'s up"-stemmen og alarm-lyden startet nesten samtidig (50ms forskjell), så de gikk oppå hverandre. Nå venter alarm-loopen til utterance.onend trigger, med 2-sek fallback for nettlesere som er upålitelige med Speech-events.',
          },
        ],
      },
    ],
  },
  {
    version: '1.5.0',
    name: 'Meritter og skader',
    pushedAt: '2026-05-13T18:00:00+02:00',
    date: 'mai 2026',
    summary:
      'Stor oppgradering av Americano-format med Bingo og Tid som nye spille-modi, skadehåndtering for spillere, og konfigurerbar belønning for de som sitter over. Spillerprofilen har fått ny Meritter-fane som viser pokaler fra topp 5-plasseringer, og enklere turnerings-ID (T1, T2, M1, M2...) gjør sporing i arkivet langt mer lesbart.',
    sections: [
      {
        type: 'new',
        title: 'Nytt',
        emoji: '✨',
        items: [
          {
            title: 'Meritter-fane i spillerprofilen',
            emoji: '🏆',
            description:
              'Ny fane som viser topp 5-plasseringer fra ferdige turneringer med pokaler. Gull, sølv, bronse + 🏆 for 4. og 5. plass. Sammendrag øverst teller antall av hver utmerkelse.',
          },
          {
            title: 'Bingo- og Tids-modus for Americano',
            emoji: '🎯',
            description:
              'To nye kampavslutningsmodi i tillegg til Totalsum og Race. Bingo: første lag som når mål stopper alle pågående kamper. Tid: hele runden spilles i fastsatt antall minutter. Begge krever manuell innleggelse av begge lag.',
          },
          {
            title: 'Skadehåndtering',
            emoji: '🩹',
            description:
              'Markér en spiller som skadet via spillerprofilen — de utelates fra nye runder, beholder eksisterende ELO og poeng, og vises nederst på Lederboard med SKADET-tag. Reversibelt: markér tilbake når de er klare igjen.',
          },
          {
            title: 'Konfigurerbar belønning for benched spillere',
            emoji: '💺',
            description:
              'Velg hva spillere som sitter over en runde får — uavgjort + snitt-poeng (default), kun snitt, full seier med lave poeng, eller ingenting. Justerbart både i oppsettet og underveis.',
            bullets: [
              'Tidligere taperhus benched på "Seire først"-ranking — nå rettferdig på begge',
              'Trer i kraft umiddelbart — eksisterende benched-runder re-beregnes',
            ],
          },
          {
            title: 'Flere parallelle turneringer',
            emoji: '⏸️',
            description:
              'Du kan nå starte en ny turnering selv om en allerede pågår — den eksisterende parkers automatisk. Pausede turneringer ligger på toppen av startsiden og kan gjenopptas med ett klikk.',
          },
          {
            title: 'Innstillinger underveis i Americano',
            emoji: '⚙️',
            description:
              'Ny "Innstillinger"-knapp i Americano-header lar deg justere navn, baner, poengsystem, ranking, finale-format og vinner-kriterier mens turneringen pågår. Endringer trer i kraft fra neste runde.',
          },
        ],
      },
      {
        type: 'design',
        title: 'Designforbedringer',
        emoji: '🎨',
        items: [
          {
            title: 'Enklere turnerings- og match-ID-er',
            emoji: '🆔',
            description:
              'Lange IDer som "am_1762093412_3947" er erstattet med T1, T2, T3 i grensesnittet. Hver kamp får M1, M2... basert på rekkefølge. Vises i arkivet, i match-listen og i detalj-modalen.',
          },
          {
            title: 'Versjons-strip i sidebar',
            emoji: '📊',
            description:
              'Padel24-app og Padel24-engine vises som klikkbare blokker i bunnen av menyen — app over engine, hver med versjonsnummer. App-knappen åpner endringsloggen, engine-knappen åpner engine-detaljene.',
          },
          {
            title: 'Vinnere på Siste turneringer + arkivet',
            emoji: '🏆',
            description:
              'Hovedsiden og arkivet viser nå begge vinnere fra finalen (lag-format), eller alle ved delt 1.plass i Americano med totalstanding-modus.',
          },
          {
            title: 'Lederboard ryddet opp',
            emoji: '📋',
            description:
              'Nivå-pillen er fjernet for renere visning. Medaljer (🥇🥈🥉) vises kun ved totalstanding-modus, etter spillerens navn.',
          },
          {
            title: 'Turneringer-fanen viser plassering',
            emoji: '🎖️',
            description:
              'Hver turnering i spillerens historikk viser nå spillerens sluttplassering med pokal-ikon og farget pill.',
          },
        ],
      },
      {
        type: 'engine',
        title: 'Engine-oppdatering',
        emoji: '⚙️',
        items: [
          {
            description:
              'Padel24 Engine 1.5.0 "Konfigurerbar engine" — kMultiplier (50% ELO-effekt for kortere format), benchedReward-config, delt rank ved likestilling, skadehåndtering filtrert i generateRound. Se engine-changelog for detaljer.',
          },
        ],
      },
      {
        type: 'bugs',
        title: 'Feilrettinger',
        emoji: '🐛',
        items: [
          {
            title: 'ELO ved årsstart vs nå viste likt',
            description:
              'Spillere uten arkiverte i-fjor-turneringer fikk yearStartElo === current ELO. Nå rekonstrueres yearStartElo fra første in-year-kamps playerEloPre.',
          },
          {
            title: '"Aktiv"-knappen krasjet for americanos',
            description:
              'Knappen tvang TournamentView (Padel24-stil) uansett turneringstype → krasj for americano. Nå rutes basert på tournament.type.',
          },
          {
            title: 'Pågående americano havnet nederst i kamp-liste',
            description:
              'handleRecordResult satte ikke playedAt → manuelle kamper sortert som tid 0. Nå riktig kronologisk plassert.',
          },
          {
            title: 'Avslutt uten finaler virket ikke',
            description: 'Native confirm() blokkert i sandboxed iframe. Erstattet med React-modal.',
          },
          {
            title: 'Turneringsresultat-fanen var tom',
            description:
              'AmericanoFinalRankingTab leste finalene fra t.finalMatches, men de lagres i t.matches med isFinal:true. Lest fra riktig sted nå.',
          },
          {
            title: 'Sortering i turneringsprofil var motsatt av PlayerHistoryModal',
            description:
              'TournamentPlayerModal hadde dobbel reverse — ferdige kamper havnet nederst i stedet for øverst.',
          },
        ],
      },
    ],
  },
  {
    version: '1.4.0',
    name: 'Parkering og bytte',
    pushedAt: '2026-05-13T12:00:00+02:00',
    date: 'mai 2026',
    summary:
      'Du kan nå parkere flere turneringer samtidig og hoppe mellom dem fra startsiden. Spillerprofilen midt i en turnering har fått ELO-graf og kompakt kamprad. Skadebytte er tilgjengelig i Americano, og bug-rapport-knappen tar nå også imot funksjonsforslag.',
    sections: [
      {
        type: 'new',
        title: 'Nytt',
        emoji: '✨',
        items: [
          {
            title: 'Parker flere turneringer samtidig',
            emoji: '⏸️',
            description:
              'Pause-knappen parkerer turneringen og frigjør plass til en ny. Pausede turneringer vises som gule kort på startsiden — alle gjenopptas med ett klikk.',
            bullets: [
              'Ingen grense på hvor mange du kan ha parkert',
              'Status og fremdrift følger med (kamper spilt, runde, tid siden pause)',
              'Pausede turneringer vises også øverst i Aktivitetsarkivet',
              'Status-fargen "Pauset" er gul (var oransje) for tydeligere kontrast',
            ],
          },
          {
            title: 'Spillerprofil midt i en turnering',
            emoji: '👤',
            description:
              'Klikk på en spiller i Padel24, Americano eller andre formater for å se DENNE turneringens data — ELO-graf, kamper, statistikk.',
            bullets: [
              'ELO-utvikling vises som graf etter hver fullførte kamp',
              'Kompakt kamprad — alle 4 spillere godt synlige med din spiller markert',
              'Stats-grid: seire-tap, score-diff, hjemme-borte',
              '"Full historikk"-knapp åpner global profil på tvers av turneringer',
            ],
          },
          {
            title: 'Skadebytte i Americano',
            emoji: '⇄',
            description:
              'Bytt ut en spiller midt i turneringen — kommende kamper bruker innbytteren, ferdige står som de er. Samme flyt som Padel24.',
          },
          {
            title: 'Fane-navigering for runder i Americano',
            emoji: '🗂️',
            description:
              'Hver runde får sin egen fane — gå tilbake og rediger gamle resultater hvis noe ble feil. Finaler får egen fane når de starter.',
          },
          {
            title: 'Funksjonsforslag i bug-rapport',
            emoji: '💡',
            description:
              'Bug-rapport-knappen heter nå "Bug / forslag". Velg om du rapporterer en feil eller foreslår en ny funksjon. Forslag markeres grønt i arkivet og kan filtreres separat.',
          },
          {
            title: 'Sporings-ID-er i arkivet',
            emoji: '#',
            description:
              'Kampdetalj-modalen viser Turnerings-ID og Match-ID — globalt unike, klikkbare for kopiering. Kun synlig i arkivet, for sporing og fremtidig referanse.',
          },
        ],
      },
      {
        type: 'engine',
        title: 'Engine-oppdatering',
        emoji: '⚙️',
        items: [
          {
            title: 'Padel24 Engine bumpet til 1.4.0 — "Pause og bytte"',
            description:
              'Engine har fått unike ID-er på alle turneringer, ny replacePlayerInAmericano-funksjon, og smartere håndtering av innbytter-merkelapper. Se "Om Padel24 Engine"-siden under utviklingsmodus for fullstendig teknisk endringslogg.',
          },
        ],
      },
      {
        type: 'design',
        title: 'Designforbedringer',
        emoji: '🎨',
        items: [
          {
            title: 'Tydeligere detaljer-knapp i Alle kamper-arkivet',
            description:
              'Hvert kamprad har nå et øye-ikon til venstre og pil til høyre — det er åpenbart at raden er klikkbar for detaljer.',
          },
          {
            title: 'ELO-forklaringen oppdatert',
            description:
              'Forklaring av lagets snitt-ELO er flettet inn i hovedavsnittet på startsiden, så det er én sammenhengende paragraph.',
          },
        ],
      },
      {
        type: 'adjustments',
        title: 'Justeringer',
        emoji: '⚙️',
        items: [
          {
            title: 'Default 5 baner i Americano-oppsett',
            description:
              'Spillerkapasitet (antall som kan spille samtidig) vises tydelig under bane-velgeren.',
          },
          {
            title: 'Default tidsplan i Padel24: "Én kamp gap"',
            description:
              'Det vanlige valget for fase-pacing er nå satt som default — mindre ventetid mellom kamper.',
          },
          {
            title: 'Innbytter-merke vises kun ved relevant bytte',
            description:
              'Spillere byttet ut FØR sin første kamp får ikke lenger merket — det hører bare ferdig-spilte spillere til.',
          },
        ],
      },
      {
        type: 'bugs',
        title: 'Feilrettinger',
        emoji: '🐛',
        items: [
          {
            title: 'Score-lagring ved tabb mellom kamper',
            description:
              'Tabb fra én kamps score til neste kamps score lagrer nå den første automatisk. Før gikk kun lagring ved klikk utenfor.',
          },
          {
            title: 'ID-kollisjon ved flere pausede turneringer',
            description:
              'Tidligere kunne demo-turneringer dele samme interne id og overskrive hverandre i pause-listen. Engine 1.4.0 fikser dette ved å garantere unike ID-er på alle turneringer.',
          },
        ],
      },
    ],
  },
  {
    version: '1.3.1',
    name: 'Alle kamper',
    pushedAt: '2026-05-13T10:09:00+02:00',
    date: 'mai 2026',
    summary:
      'Mindre påbygg på Aktivitetsarkiv som gir én samlet oversikt over alle spilte kamper på tvers av aktiviteter, samt justerte standardverdier i Americano-oppsettet.',
    sections: [
      {
        type: 'new',
        title: 'Nytt',
        emoji: '✨',
        items: [
          {
            title: 'Tab-toggle i Aktivitetsarkiv',
            emoji: '🗂️',
            description: 'To visninger styres av en fane øverst:',
            bullets: [
              'Aktiviteter (standard) — den eksisterende lista over turneringer og enkeltkamp-samlinger',
              'Alle kamper — en flat kronologisk liste over hver enkelt spilte kamp',
            ],
          },
          {
            title: 'Alle kamper-fanen',
            emoji: '📋',
            bullets: [
              'Hver kamp vises som en isolert blokk med egen header-strip (type-tagg + aktivitetsnavn + dato) over selve kamp-raden — ingen overlapp mellom turneringsnavn og spillernavn',
              'Selve kampen rendres med UniversalMatchRow, slik at designet er identisk med resten av appen',
              'Tydelig type-tagg (P24 / AM / EK) viser hvilken aktivitet kampen kommer fra',
              'Sortert nyeste først, på tvers av turneringer og enkeltkamper',
              'Type-filter viser bare de typene som finnes i datasettet (dynamisk)',
              'Søk på spillernavn eller aktivitetsnavn',
            ],
          },
          {
            title: 'Klikk-interaksjoner',
            emoji: '🎯',
            bullets: [
              'Klikk på header-stripen → åpner hele aktiviteten (turnering eller enkeltkamp-liste)',
              'Klikk på kamp-raden → kampdetalj-modal med score, sett-resultater, spillere, daværende ELO og ELO-endring',
              'Klikk på et spillernavn → åpner spillerprofilen',
            ],
          },
          {
            title: 'Endringslogg i appen',
            emoji: '📰',
            description:
              'Denne siden! Releaser dokumenteres direkte i appen, tilgjengelig via menyen.',
          },
        ],
      },
      {
        type: 'tech',
        title: 'Tekniske forbedringer',
        emoji: '🔧',
        items: [
          {
            title: 'Gjenbruk av eksisterende byggeklosser',
            description:
              'Nye komponenter bygger på UniversalMatchRow, getTeamPlayerIds og Padel24Engine.getTournamentType — ingen duplisert logikk. Håndterer både slot-format (Padel24) og flat-format (Americano, enkeltkamper) transparent.',
          },
          {
            title: 'Stabil sortering',
            description:
              'Kamper innen samme aktivitet sorteres etter fase, runde og bane for naturlig rekkefølge; på tvers av aktiviteter brukes archivedAt (nyeste først).',
          },
        ],
      },
      {
        type: 'adjustments',
        title: 'Justeringer',
        emoji: '⚙️',
        items: [
          {
            title: 'Americano — nye standardverdier',
            description:
              'Standardverdier for nye Americano-oppsett er endret for å passe klassisk americano-spill bedre. Eksisterende konfigurasjoner berøres ikke.',
            bullets: ['Poengsystem: Poeng (var Games)', 'Mål-poeng: 24 (var 32)'],
          },
        ],
      },
    ],
  },
  {
    version: '1.3.0',
    name: 'Enkeltkamper',
    date: 'mai 2026',
    summary:
      'Stort milepælsslipp som introduserer enkeltkamp-registrering, americano-format, og en gjennomarbeidet brukeropplevelse på tvers av plattformen.',
    sections: [
      {
        type: 'new',
        title: 'Nytt',
        emoji: '✨',
        items: [
          {
            title: 'Enkeltkamp-modul',
            emoji: '🆕',
            description:
              'Registrer enkeltstående padel-kamper utenfor turneringer. Standard padel-format (best av 3 sett, padel-regler 6-0…6-4, 7-5, 7-6). ELO oppdateres umiddelbart med Weighted Elo MOV-formel (Angelini et al., 2022) — som bedre fanger dominans gjennom antall games enn rene sett-resultater.',
          },
          {
            title: 'Americano (miniturnering)',
            emoji: '🏆',
            description:
              'Roterende makker-format med smart trekning som garanterer minst gjentakelse over flere runder.',
            bullets: [
              'Støtter hvilket som helst antall spillere (4+, også oddetall — sittover-rotasjon er innebygd)',
              'Tre poengsystemer: Games / Sett & games / Direkte poeng (race eller totalsum)',
              'Manuell avslutning — admin styrer når turneringen er ferdig eller går til finaler',
              'Finalegenerering basert på stilling (1+3 vs 2+4 osv.)',
              'ELO oppdateres for hver kamp som vanlig',
              'Spillere som sitter over får kompensasjons-poeng for ikke å straffes',
            ],
          },
          {
            title: 'Spillerprofil-redesign',
            emoji: '👤',
            bullets: [
              '"Alle kamper" er nå standard-fanen (var "Turneringer")',
              'Kronologisk blandet visning av turneringskamper og enkeltkamper',
              'Type-tagg (P24/EK/AM) viser hvilken aktivitet hver kamp tilhører',
              'Per-kamp daværende ELO vises korrekt (ikke nåværende)',
              'ELO-graf akkumuleres fra årets start for å fungere på alle kamper',
            ],
          },
          {
            title: 'Aktivitetsarkiv (tidligere "Turneringsarkiv")',
            emoji: '📊',
            bullets: [
              'Omdøpt for å reflektere at alle aktivitetstyper er samlet',
              'Type-filter på toppen: Alle / Padel24 / Enkeltkamper',
              'Enkeltkamper grupperes som én virtuell "Enkeltkamper"-aktivitet',
              'Type-tagger med farger på hver rad for rask gjenkjenning',
            ],
          },
          {
            title: 'Andre turneringer-side',
            emoji: '🎨',
            description: 'Organisert i tre kategorier med klare seksjoner:',
            bullets: [
              'Enkeltkamper — tilgjengelig nå',
              'Klubbmesterskap — kommer snart',
              'Miniturneringer — 8 formater varsler i pipeline (Americano implementert, resten er på vei)',
            ],
          },
          {
            title: 'Navigasjon',
            emoji: '📋',
            description:
              'Ny menystruktur: Hjem, Opprett Padel24-turnering, Andre turneringer, Spillerdatabase, Aktivitetsarkiv, Om Padel24 Engine, Bug-arkiv (med varselindikator når åpne bugs).',
          },
          {
            title: 'Bug-rapportering',
            emoji: '🐛',
            bullets: [
              'Flytende "Report bug"-knapp på alle sider',
              'Auto-generert Claude-prompt med side-spesifikk kontekst',
              'E-post sendes automatisk til utviklingsteamet (Web3Forms-integrasjon)',
              'Lokal bug-arkiv med "fikset"-merking',
              'Visuell varsel i menyen når det er åpne bugs',
            ],
          },
        ],
      },
      {
        type: 'design',
        title: 'Designforbedringer',
        emoji: '🎨',
        items: [
          {
            title: 'Felles match-row-design på tvers av moduler',
            description:
              'Padel24, Americano og fremtidige formater bruker nå samme tabell-design — endringer ett sted slår igjennom overalt.',
            bullets: [
              'Hjemmelag (blå tint) og Bortelag (oransje tint)',
              'Lag-snitt-ELO med grønn for sterkeste lag, grå for svakeste',
              'ELO-endring under snitt-tallet',
              'Symmetrisk score-layout med "vs" mellom lagene',
              'Nivå-pill (1-9) eller gruppe-pill (A-D) basert på kontekst',
            ],
          },
          {
            title: 'Felles setup-layout',
            description:
              'Turneringsoppsett bruker nå samme byggeklosser (SetupCard, SetupNumberInput, SetupPillToggle osv.) — konsistent struktur, fleksible farger og overskrifter.',
          },
          {
            title: 'Detaljert kampdetaljer',
            bullets: [
              'Alltid plass til 3 sett (ingen layout-skift når 3. sett legges til)',
              'Sett-resultater vises mellom lag 1 (øverst) og lag 2 (nederst)',
              'Nivå-pills og daværende ELO på alle spillere',
              'Statistikk-grid: total games, vinner-dominans (%), ELO-diff, MOV-multiplier',
              'Format-info i bunnen',
            ],
          },
          {
            title: 'Kompakte UI-valg',
            bullets: [
              'Pill-toggle for valg (Games / Sett / Poeng osv.)',
              '+/- knapper for tallinput (baner, runder)',
              'Checkbox for "Tell antall seire først" istedet for radio-knapper',
            ],
          },
        ],
      },
      {
        type: 'tech',
        title: 'Tekniske forbedringer',
        emoji: '🔧',
        items: [
          {
            title: 'Pre-match ELO-logging',
            description:
              'Hver kamp lagrer nå spillerens daværende ELO på matchen. Dette gjør at kamphistorikken viser korrekt ELO på tidspunktet kampen ble spilt, ikke nåværende.',
          },
          {
            title: 'ELO-konsistens',
            description:
              'allPlayers-tabellen er nå autoritativ ELO-kilde. Synkroniseres ved arkivering av turneringer for å sikre konsistens mellom enkeltkamper, turneringer og spillerprofil.',
          },
          {
            title: 'Smart Americano-algoritme',
            description:
              '500 iterasjoner med cost-minimization velger optimal trekning hver runde. Verifisert: 8 spillere × 10 runder utnytter alle 28 mulige par, maks 2 ganger per par.',
          },
          {
            title: 'Turneringstype-arkitektur',
            description:
              'Turneringstyper definert i engine (Padel24, Klubbmesterskap, Americano-varianter, Enkeltkamper) — alle med farger og forkortelser klar for bruk.',
          },
        ],
      },
      {
        type: 'bugs',
        title: 'Feilrettinger',
        emoji: '🐛',
        items: [
          {
            description:
              'Logo-klikk fra Americano-side krasjet HomeView (nå håndterer alle turneringstyper)',
          },
          {
            description:
              'Enkeltkamper forsvant ved Storage-feil (nå rollback ved feil + skriv-til-Storage-først)',
          },
          {
            description:
              'Navigasjon fra arkiv tilbake til enkeltkamper returnerer nå til arkivet, ikke "Andre formater"',
          },
          {
            description:
              'Score-input i Americano matcher nå Padel24-stil med separate felt og "vs"',
          },
          {
            description:
              'ELO-graf i spillerprofil fungerer nå for alle kamper (akkumuleres fra eloChange)',
          },
        ],
      },
    ],
  },
  {
    version: '1.2.0',
    name: 'Nivåskala',
    date: 'mai 2026',
    sections: [
      {
        type: 'new',
        title: 'Nytt',
        emoji: '✨',
        items: [
          { description: '9-nivå ELO-skala (500–3000) erstatter forrige 4-nivå system' },
          { description: 'Detaljerte ferdighet-beskrivelser per nivå for selvplassering' },
          { description: 'Nivå 1 (Nybegynner) til Nivå 9 (Toppnivå)' },
          { description: '~300 ELO mellom nivåer for tydelig progresjon' },
          { description: 'Inspirert av Playtomic, MATCHi og NTRP-tilpasninger' },
        ],
      },
    ],
  },
  {
    version: '1.1.0',
    name: 'Pacing',
    date: 'mai 2026',
    sections: [
      {
        type: 'new',
        title: 'Nytt',
        emoji: '✨',
        items: [
          { description: 'Tre pacing-modi for tidsfordeling av kamper i samme fase' },
          { description: 'ELO-nivåer sentralisert (Nybegynner / Mosjonist / Konkurranse / Elite)' },
          { description: 'Årlig ELO-baseline (yearStartElo) for ferskere tall' },
        ],
      },
    ],
  },
  {
    version: '1.0.0',
    name: 'Speilrotasjon',
    date: 'mai 2026',
    summary: 'Initial release.',
    sections: [
      {
        type: 'new',
        title: 'Inkludert i første versjon',
        emoji: '✨',
        items: [
          { description: 'Padel24 turneringsformat med rangerte finaler' },
          { description: 'ELO med K=64 og Margin-of-Victory bonus' },
          { description: 'Speilrotasjon-trekning (samme makker spilles tidlig, så bytte)' },
          { description: 'Variert-modus med 4 prioriterte regler for jevne kamper' },
          { description: 'Persistent ELO på tvers av turneringer' },
          { description: 'Spillerdatabase med +250 spillere i system-DB' },
          { description: 'Live banepad-tabell for iPad' },
          { description: 'Rangerte finaler (1.–N. plass etter gruppespill)' },
          { description: 'Replacement-system for skadeerstatninger midt i turneringer' },
        ],
      },
    ],
  },
];

// App version — derived from the newest changelog entry. Extracted verbatim
// from the monolith (legacy/App.tsx); the monolith imports it from here.
export const APP_VERSION = CHANGELOG_DATA[0]?.version || '1.0.0';

// Farge-mapping per seksjons-type
export const CHANGELOG_SECTION_STYLES = {
  new: { bg: 'rgba(132, 204, 22, 0.12)', border: 'rgba(132, 204, 22, 0.45)', text: '#3f6212' }, // lime
  design: { bg: 'rgba(96, 165, 250, 0.12)', border: 'rgba(96, 165, 250, 0.45)', text: '#1e40af' }, // blue
  engine: { bg: 'rgba(124, 58, 237, 0.10)', border: 'rgba(124, 58, 237, 0.50)', text: '#5b21b6' }, // dyp lilla — referer til engine-changelog
  tech: { bg: 'rgba(168, 85, 247, 0.12)', border: 'rgba(168, 85, 247, 0.45)', text: '#6b21a8' }, // purple
  bugs: { bg: 'rgba(244, 63, 94, 0.12)', border: 'rgba(244, 63, 94, 0.45)', text: '#9f1239' }, // rose
  adjustments: {
    bg: 'rgba(251, 191, 36, 0.12)',
    border: 'rgba(251, 191, 36, 0.45)',
    text: '#92400e',
  }, // yellow
};

// Formaterer en ISO-timestamp til norsk dato + klokkeslett.
// Eksempel: '2026-05-13T10:09:00+02:00' → '13. mai 2026 kl. 10:09'
// Returnerer null hvis input mangler eller er ugyldig.
export function formatPushedAt(iso) {
  if (!iso) return null;
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleString('no-NO', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Oslo',
    });
  } catch {
    return null;
  }
}
